/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: data-contracts */

/* Template custom: data-contract-jsdoc */
export enum ApiTypeOfOrigin {
  Natural = "natural",
  Synthetic = "synthetic",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTypeOfHistoryOfOriginType {
  Gift = "gift",
  Purchase = "purchase",
  Inheritance = "inheritance",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTradeType {
  Etc = "etc",
  Otc = "otc",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTradeDirectionType {
  Long = "long",
  Short = "short",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTaxIDType {
  Resident = "resident",
  NonResident = "nonResident",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTaxAgentType {
  Client = "client",
  Bank = "bank",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiTaskOfTheFundType {
  AssetsProtection = "assetsProtection",
  AssetsManagement = "assetsManagement",
  AssetTransfer = "assetTransfer",
  ConfidentialityAssurance = "confidentialityAssurance",
  FinancialOptimization = "financialOptimization",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiStrategyType {
  GrowthStock = "growthStock",
  ValueStock = "valueStock",
}

/* Template custom: data-contract-jsdoc */
export enum ApiStrategyBasicPositionType {
  BuyingCall = "buyingCall",
  SellingCall = "sellingCall",
  BuyingPut = "buyingPut",
  SellingPut = "sellingPut",
}

/* Template custom: data-contract-jsdoc */
export enum ApiShapeType {
  Cushion = "cushion",
  Marquise = "marquise",
  Radiant = "radiant",
  Pear = "pear",
  Round = "round",
  Oval = "oval",
  Emerald = "emerald",
  Princess = "princess",
  Heart = "heart",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiSellerType {
  LegalEntity = "legalEntity",
  Person = "person",
}

/* Template custom: data-contract-jsdoc */
export enum ApiSecuritiesAndStocksEnum {
  Adr = "adr",
  Edr = "edr",
  Gdr = "gdr",
  DepositaryReceipts = "depositaryReceipts",
  PreferredStock = "preferredStock",
  Regular = "regular",
}

/* Template custom: data-contract-jsdoc */
export enum ApiResidentialRealEstateType {
  Flat = "flat",
  Studio = "studio",
  Apartment = "apartment",
  Condominium = "condominium",
  House = "house",
  Cottage = "cottage",
  Duplex = "duplex",
  Bungalow = "bungalow",
  Chalet = "chalet",
  Townhouse = "townhouse",
  Ranch = "ranch",
  Penthouse = "penthouse",
  Villa = "villa",
  Mansion = "mansion",
  Castle = "castle",
  Estate = "estate",
}

/* Template custom: data-contract-jsdoc */
export enum ApiRatingType {
  AAA = "AAA",
  AA = "AA",
  A = "A",
  BBB = "BBB",
  Bb = "bb",
  B = "B",
  CCCp = "CCCp",
  CCC = "CCC",
  CCCCm = "C_CCCm",
  D = "D",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPublicFundType {
  VentureCapitalFund = "VentureCapitalFund",
  HedgeFund = "HedgeFund",
  PrivateFund = "PrivateFund",
  RealEstateFund = "RealEstateFund",
  IndexedFund = "IndexedFund",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPrivateDocumentType {
  UNILATERAL = "UNILATERAL",
  BILATERAL = "BILATERAL",
  MULTILATERAL = "MULTILATERAL",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPrivateDocumentCategory {
  PRIVATE_AGREEMENTS = "PRIVATE_AGREEMENTS",
  PUBLIC_AGREEMENTS = "PUBLIC_AGREEMENTS",
  INFORMATION_SHEETS = "INFORMATION_SHEETS",
  BANK_DOCUMENTS = "BANK_DOCUMENTS",
  PAYMENT_DOCUMENTS = "PAYMENT_DOCUMENTS",
  POWERS = "POWERS",
  CORPORATE_DOCUMENTS = "CORPORATE_DOCUMENTS",
  FAMILY_DOCUMENTS = "FAMILY_DOCUMENTS",
  OTHER = "OTHER",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPreciousGemstonesType {
  No = "no",
  Diamond = "diamond",
  Emerald = "emerald",
  Ruby = "ruby",
  Sapphire = "sapphire",
  Alexandrite = "alexandrite",
  NaturalPearl = "naturalPearl",
  Spinel = "spinel",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPhoneCode {
  Value1 = "+1",
  Value1242 = "+1242",
  Value1246 = "+1246",
  Value1264 = "+1264",
  Value1268 = "+1268",
  Value1284 = "+1284",
  Value1340 = "+1340",
  Value1441 = "+1441",
  Value1473 = "+1473",
  Value1649 = "+1649",
  Value1664 = "+1664",
  Value1670 = "+1670",
  Value1671 = "+1671",
  Value1684 = "+1684",
  Value1758 = "+1758",
  Value1767 = "+1767",
  Value1784 = "+1784",
  Value1849 = "+1849",
  Value1868 = "+1868",
  Value1869 = "+1869",
  Value1876 = "+1876",
  Value1939 = "+1939",
  Value20 = "+20",
  Value211 = "+211",
  Value212 = "+212",
  Value213 = "+213",
  Value216 = "+216",
  Value218 = "+218",
  Value220 = "+220",
  Value221 = "+221",
  Value222 = "+222",
  Value223 = "+223",
  Value224 = "+224",
  Value225 = "+225",
  Value226 = "+226",
  Value227 = "+227",
  Value228 = "+228",
  Value229 = "+229",
  Value230 = "+230",
  Value231 = "+231",
  Value232 = "+232",
  Value233 = "+233",
  Value234 = "+234",
  Value235 = "+235",
  Value236 = "+236",
  Value237 = "+237",
  Value238 = "+238",
  Value239 = "+239",
  Value240 = "+240",
  Value241 = "+241",
  Value242 = "+242",
  Value243 = "+243",
  Value244 = "+244",
  Value245 = "+245",
  Value246 = "+246",
  Value248 = "+248",
  Value249 = "+249",
  Value250 = "+250",
  Value251 = "+251",
  Value252 = "+252",
  Value253 = "+253",
  Value254 = "+254",
  Value255 = "+255",
  Value256 = "+256",
  Value257 = "+257",
  Value258 = "+258",
  Value260 = "+260",
  Value261 = "+261",
  Value262 = "+262",
  Value263 = "+263",
  Value264 = "+264",
  Value265 = "+265",
  Value266 = "+266",
  Value267 = "+267",
  Value268 = "+268",
  Value269 = "+269",
  Value27 = "+27",
  Value290 = "+290",
  Value291 = "+291",
  Value297 = "+297",
  Value298 = "+298",
  Value299 = "+299",
  Value30 = "+30",
  Value31 = "+31",
  Value32 = "+32",
  Value33 = "+33",
  Value34 = "+34",
  Value345 = "+345",
  Value350 = "+350",
  Value351 = "+351",
  Value352 = "+352",
  Value353 = "+353",
  Value354 = "+354",
  Value355 = "+355",
  Value356 = "+356",
  Value357 = "+357",
  Value358 = "+358",
  Value359 = "+359",
  Value36 = "+36",
  Value370 = "+370",
  Value371 = "+371",
  Value372 = "+372",
  Value373 = "+373",
  Value374 = "+374",
  Value375 = "+375",
  Value376 = "+376",
  Value377 = "+377",
  Value378 = "+378",
  Value379 = "+379",
  Value380 = "+380",
  Value381 = "+381",
  Value382 = "+382",
  Value385 = "+385",
  Value386 = "+386",
  Value387 = "+387",
  Value389 = "+389",
  Value39 = "+39",
  Value40 = "+40",
  Value41 = "+41",
  Value420 = "+420",
  Value421 = "+421",
  Value423 = "+423",
  Value43 = "+43",
  Value44 = "+44",
  Value45 = "+45",
  Value46 = "+46",
  Value47 = "+47",
  Value48 = "+48",
  Value49 = "+49",
  Value500 = "+500",
  Value501 = "+501",
  Value502 = "+502",
  Value503 = "+503",
  Value504 = "+504",
  Value505 = "+505",
  Value506 = "+506",
  Value507 = "+507",
  Value508 = "+508",
  Value509 = "+509",
  Value51 = "+51",
  Value52 = "+52",
  Value53 = "+53",
  Value54 = "+54",
  Value55 = "+55",
  Value56 = "+56",
  Value57 = "+57",
  Value58 = "+58",
  Value590 = "+590",
  Value591 = "+591",
  Value593 = "+593",
  Value594 = "+594",
  Value595 = "+595",
  Value596 = "+596",
  Value597 = "+597",
  Value598 = "+598",
  Value599 = "+599",
  Value60 = "+60",
  Value61 = "+61",
  Value62 = "+62",
  Value63 = "+63",
  Value64 = "+64",
  Value65 = "+65",
  Value66 = "+66",
  Value670 = "+670",
  Value672 = "+672",
  Value673 = "+673",
  Value674 = "+674",
  Value675 = "+675",
  Value676 = "+676",
  Value677 = "+677",
  Value678 = "+678",
  Value679 = "+679",
  Value680 = "+680",
  Value681 = "+681",
  Value682 = "+682",
  Value683 = "+683",
  Value685 = "+685",
  Value686 = "+686",
  Value687 = "+687",
  Value688 = "+688",
  Value689 = "+689",
  Value690 = "+690",
  Value691 = "+691",
  Value692 = "+692",
  Value7 = "+7",
  Value77 = "+77",
  Value81 = "+81",
  Value82 = "+82",
  Value84 = "+84",
  Value850 = "+850",
  Value852 = "+852",
  Value853 = "+853",
  Value855 = "+855",
  Value856 = "+856",
  Value86 = "+86",
  Value872 = "+872",
  Value880 = "+880",
  Value886 = "+886",
  Value90 = "+90",
  Value91 = "+91",
  Value92 = "+92",
  Value93 = "+93",
  Value94 = "+94",
  Value95 = "+95",
  Value960 = "+960",
  Value961 = "+961",
  Value962 = "+962",
  Value963 = "+963",
  Value964 = "+964",
  Value965 = "+965",
  Value966 = "+966",
  Value967 = "+967",
  Value968 = "+968",
  Value970 = "+970",
  Value971 = "+971",
  Value972 = "+972",
  Value973 = "+973",
  Value974 = "+974",
  Value975 = "+975",
  Value976 = "+976",
  Value977 = "+977",
  Value98 = "+98",
  Value992 = "+992",
  Value993 = "+993",
  Value994 = "+994",
  Value995 = "+995",
  Value996 = "+996",
  Value998 = "+998",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPermittedUseType {
  Recreational = "recreational",
  Sanitary = "sanitary",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPaymentPriority {
  High = "high",
  Medium = "medium",
  Low = "low",
}

/* Template custom: data-contract-jsdoc */
export enum ApiPaymentCategory {
  Housing = "housing",
  Education = "education",
  Children = "children",
  Healthcare = "healthcare",
  Sports = "sports",
  Subscription = "subscription",
  Taxes = "taxes",
  Services = "services",
  Charity = "charity",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiOwnershipType {
  DIRECT = "DIRECT",
  INDIRECT = "INDIRECT",
}

/* Template custom: data-contract-jsdoc */
export enum ApiOverTheCounterOptionsType {
  Call = "call",
  Put = "put",
}

/* Template custom: data-contract-jsdoc */
export enum ApiOptionStyleType {
  European = "european",
  American = "american",
  Asian = "asian",
  QuasiAmerican = "quasiAmerican",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiMyFundType {
  Revocable = "revocable",
  Irrevocable = "irrevocable",
}

/* Template custom: data-contract-jsdoc */
export enum ApiMetalType {
  WhiteGold = "whiteGold",
  YellowGold = "yellowGold",
  RoseGold = "roseGold",
  Silver = "silver",
  Platinum = "platinum",
  Steel = "steel",
  Titanium = "titanium",
  Ceramic = "ceramic",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiMetalAccountType {
  Gold = "gold",
  Silver = "silver",
  Platinum = "platinum",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiManagerialRightsType {
  Yes = "yes",
  No = "no",
  Proportionally = "proportionally",
  DisproportionateUpward = "disproportionateUpward",
  DisproportionateDownward = "disproportionateDownward",
}

/* Template custom: data-contract-jsdoc */
export enum ApiManagementStructureType {
  Direct = "direct",
  TrustAgreement = "trustAgreement",
  NominalOwnership = "nominalOwnership",
}

/* Template custom: data-contract-jsdoc */
export enum ApiManagementBodyType {
  Manager = "manager",
  BoardOfDirectors = "boardOfDirectors",
  ManagementCompany = "managementCompany",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiJewelryTypeName {
  Brand = "brand",
  Relic = "relic",
  CustomOrder = "customOrder",
  Vintage = "vintage",
}

/* Template custom: data-contract-jsdoc */
export enum ApiJewelryType {
  Ring = "ring",
  Earrings = "earrings",
  Necklace = "necklace",
  Pendant = "pendant",
  Bracelet = "bracelet",
  Brooch = "brooch",
  Cufflinks = "cufflinks",
  Clasp = "clasp",
  Tiara = "tiara",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiItemConditionType {
  BrandNew = "brandNew",
  Used = "used",
}

/* Template custom: data-contract-jsdoc */
export enum ApiIssuerAndExchangePlatformType {
  InformationSystemOperator = "informationSystemOperator",
  Bank = "bank",
  LegalEntity = "legalEntity",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiFuturesType {
  DeliveryBased = "deliveryBased",
  CashSettled = "cashSettled",
}

/* Template custom: data-contract-jsdoc */
export enum ApiFundUsageStrategyType {
  Strategic = "strategic",
  Personal = "personal",
  Commercial = "commercial",
  Investment = "investment",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiForwardsType {
  DeliveryBased = "deliveryBased",
  CashSettled = "cashSettled",
}

/* Template custom: data-contract-jsdoc */
export enum ApiFluorescenceType {
  None = "none",
  Slight = "slight",
  Medium = "medium",
  Strong = "strong",
  VeryStrong = "veryStrong",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiFiatCurrenciesType {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BYR = "BYR",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHF = "CHF",
  CLF = "CLF",
  CLP = "CLP",
  CNH = "CNH",
  CNY = "CNY",
  COP = "COP",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GGP = "GGP",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  IMP = "IMP",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JEP = "JEP",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LTL = "LTL",
  LVL = "LVL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SLE = "SLE",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  STD = "STD",
  SYP = "SYP",
  SVC = "SVC",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  UYU = "UYU",
  UZS = "UZS",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XAG = "XAG",
  XAU = "XAU",
  XCD = "XCD",
  XDR = "XDR",
  XOF = "XOF",
  XPF = "XPF",
  YER = "YER",
  ZAR = "ZAR",
  ZMK = "ZMK",
  ZMW = "ZMW",
  ZWL = "ZWL",
}

/* Template custom: data-contract-jsdoc */
export enum ApiExchangeOptionsType {
  Call = "call",
  Put = "put",
}

/* Template custom: data-contract-jsdoc */
export enum ApiDebitType {
  CurrentAccount = "currentAccount",
  Deposit = "deposit",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCutAndPolishType {
  Excellent = "excellent",
  VeryGood = "veryGood",
  Good = "good",
  Fair = "fair",
  Poor = "poor",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCurrenciesType {
  BTC = "BTC",
  ETH = "ETH",
  USDT = "USDT",
  BNB = "BNB",
  SOL = "SOL",
  XRP = "XRP",
  USDC = "USDC",
  ADA = "ADA",
  AVAX = "AVAX",
  DOGE = "DOGE",
  DOT = "DOT",
  TRX = "TRX",
  LINK = "LINK",
  MATIC = "MATIC",
  WBTC = "WBTC",
  SHIB = "SHIB",
  LTC = "LTC",
  DAI = "DAI",
  BCH = "BCH",
  ICP = "ICP",
  UNI = "UNI",
  XLM = "XLM",
  LEO = "LEO",
  OKB = "OKB",
  XMR = "XMR",
  ETC = "ETC",
  ATOM = "ATOM",
  CRO = "CRO",
  FIL = "FIL",
  TUSD = "TUSD",
  NEAR = "NEAR",
  BTCB = "BTCB",
  VET = "VET",
  INJ = "INJ",
  RUNE = "RUNE",
  LDO = "LDO",
  RNDR = "RNDR",
  ALGO = "ALGO",
  AAVE = "AAVE",
  GRT = "GRT",
  EGLD = "EGLD",
  STX = "STX",
  QNT = "QNT",
  FTT = "FTT",
  HNT = "HNT",
  WEMIX = "WEMIX",
  HBAR = "HBAR",
  MKR = "MKR",
  BUSD = "BUSD",
  FTM = "FTM",
  FLOW = "FLOW",
  THETA = "THETA",
  SAND = "SAND",
  KCS = "KCS",
  BSV = "BSV",
  SNX = "SNX",
  AXS = "AXS",
  MANA = "MANA",
  NEO = "NEO",
  IOTA = "IOTA",
  XTZ = "XTZ",
  EOS = "EOS",
  KAVA = "KAVA",
  GALA = "GALA",
  KLAY = "KLAY",
  MINA = "MINA",
  WOO = "WOO",
  Ar = "ar",
  CFX = "CFX",
  XEC = "XEC",
  FXS = "FXS",
  CHZ = "CHZ",
  ROSE = "ROSE",
  XDC = "XDC",
  CAKE = "CAKE",
  CRV = "CRV",
  GNO = "GNO",
  DYDX = "DYDX",
  ELF = "ELF",
  FET = "FET",
  RPL = "RPL",
  Gt = "gt",
  AKT = "AKT",
  ZEC = "ZEC",
  TWT = "TWT",
  CSPR = "CSPR",
  GAS = "GAS",
  NEXO = "NEXO",
  Ht = "ht",
  COMP = "COMP",
  Value1INCH = "1INCH",
  ZIL = "ZIL",
  AGIX = "AGIX",
  IOTX = "IOTX",
  Sc = "sc",
  STORJ = "STORJ",
  DASH = "DASH",
  HOT = "HOT",
  USDP = "USDP",
  ILV = "ILV",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCryptoWalletType {
  Hot = "hot",
  Cold = "cold",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCountry {
  AD = "AD",
  AF = "AF",
  AX = "AX",
  AL = "AL",
  DZ = "DZ",
  AS = "AS",
  AO = "AO",
  AI = "AI",
  AQ = "AQ",
  AG = "AG",
  AR = "AR",
  AM = "AM",
  AW = "AW",
  AC = "AC",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BD = "BD",
  BB = "BB",
  BY = "BY",
  BE = "BE",
  BZ = "BZ",
  BJ = "BJ",
  BM = "BM",
  BT = "BT",
  BO = "BO",
  BQBO = "BQ-BO",
  BA = "BA",
  BW = "BW",
  BR = "BR",
  IO = "IO",
  BN = "BN",
  BG = "BG",
  BF = "BF",
  BI = "BI",
  KH = "KH",
  CM = "CM",
  CA = "CA",
  CV = "CV",
  KY = "KY",
  CF = "CF",
  TD = "TD",
  CL = "CL",
  CN = "CN",
  CX = "CX",
  CC = "CC",
  CO = "CO",
  KM = "KM",
  CD = "CD",
  CG = "CG",
  CK = "CK",
  CR = "CR",
  CI = "CI",
  HR = "HR",
  CU = "CU",
  CW = "CW",
  CY = "CY",
  CZ = "CZ",
  DK = "DK",
  DJ = "DJ",
  DM = "DM",
  DO = "DO",
  EC = "EC",
  EG = "EG",
  SV = "SV",
  GQ = "GQ",
  ER = "ER",
  EE = "EE",
  SZ = "SZ",
  ET = "ET",
  FK = "FK",
  FO = "FO",
  FJ = "FJ",
  FI = "FI",
  FR = "FR",
  GF = "GF",
  PF = "PF",
  TF = "TF",
  GA = "GA",
  GM = "GM",
  GE = "GE",
  DE = "DE",
  GH = "GH",
  GI = "GI",
  GR = "GR",
  GL = "GL",
  GD = "GD",
  GP = "GP",
  GU = "GU",
  GT = "GT",
  GG = "GG",
  GN = "GN",
  GW = "GW",
  GY = "GY",
  HT = "HT",
  HM = "HM",
  HN = "HN",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IR = "IR",
  IQ = "IQ",
  IE = "IE",
  IM = "IM",
  IL = "IL",
  IT = "IT",
  JM = "JM",
  JP = "JP",
  JE = "JE",
  JOR = "JOR",
  KZ = "KZ",
  KE = "KE",
  KI = "KI",
  KP = "KP",
  KR = "KR",
  XK = "XK",
  KW = "KW",
  KG = "KG",
  LA = "LA",
  LV = "LV",
  LB = "LB",
  LS = "LS",
  LR = "LR",
  LY = "LY",
  LI = "LI",
  LT = "LT",
  LU = "LU",
  MO = "MO",
  MG = "MG",
  MW = "MW",
  MY = "MY",
  MV = "MV",
  ML = "ML",
  MT = "MT",
  MH = "MH",
  MQ = "MQ",
  MR = "MR",
  MU = "MU",
  YT = "YT",
  MX = "MX",
  FM = "FM",
  MD = "MD",
  MC = "MC",
  MN = "MN",
  ME = "ME",
  MS = "MS",
  MA = "MA",
  MZ = "MZ",
  MM = "MM",
  NA = "NA",
  NR = "NR",
  NP = "NP",
  NL = "NL",
  NC = "NC",
  NZ = "NZ",
  NI = "NI",
  NE = "NE",
  NG = "NG",
  NU = "NU",
  NF = "NF",
  MK = "MK",
  GBNIR = "GB-NIR",
  MP = "MP",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PW = "PW",
  PS = "PS",
  PA = "PA",
  PG = "PG",
  PY = "PY",
  PE = "PE",
  PH = "PH",
  PN = "PN",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RU = "RU",
  RW = "RW",
  BQSA = "BQ-SA",
  BL = "BL",
  SH = "SH",
  KN = "KN",
  LC = "LC",
  MF = "MF",
  PM = "PM",
  VC = "VC",
  WS = "WS",
  SM = "SM",
  ST = "ST",
  SA = "SA",
  SN = "SN",
  RS = "RS",
  SC = "SC",
  SL = "SL",
  SG = "SG",
  BQSE = "BQ-SE",
  SX = "SX",
  SK = "SK",
  SI = "SI",
  SB = "SB",
  SO = "SO",
  ZA = "ZA",
  GS = "GS",
  SS = "SS",
  ES = "ES",
  LK = "LK",
  SD = "SD",
  SR = "SR",
  SJ = "SJ",
  SVZ = "SVZ",
  SE = "SE",
  CH = "CH",
  SY = "SY",
  TW = "TW",
  TJ = "TJ",
  TZ = "TZ",
  TH = "TH",
  TL = "TL",
  TG = "TG",
  TK = "TK",
  TO = "TO",
  TT = "TT",
  TA = "TA",
  TN = "TN",
  TR = "TR",
  TM = "TM",
  TC = "TC",
  TV = "TV",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  GB = "GB",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VU = "VU",
  VA = "VA",
  VE = "VE",
  VN = "VN",
  VG = "VG",
  VI = "VI",
  WF = "WF",
  EH = "EH",
  YE = "YE",
  ZM = "ZM",
  ZW = "ZW",
}

/* Template custom: data-contract-jsdoc */
export enum ApiContactType {
  BROKER = "BROKER",
  BANK = "BANK",
  LEGAL_ENTITY = "LEGAL_ENTITY",
  INDIVIDUAL = "INDIVIDUAL",
}

/* Template custom: data-contract-jsdoc */
export enum ApiConfidentialityLevelType {
  OpenEnded = "openEnded",
  CloseEnded = "closeEnded",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCommercialRealEstateType {
  Retail = "retail",
  Office = "office",
  Warehouse = "warehouse",
  Production = "production",
  Recreation = "recreation",
  Agricultural = "agricultural",
  Condominium = "condominium",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiColorType {
  D = "D",
  E = "E",
  F = "F",
  G = "G",
  H = "H",
  I = "I",
  J = "J",
  K = "K",
  L = "L",
  M = "M",
  N = "N",
  O = "O",
  P = "P",
  Q = "Q",
  R = "R",
  S = "S",
  T = "T",
  U = "U",
  V = "V",
  W = "W",
  X = "X",
  Y = "Y",
  Z = "Z",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiClassOfSharesType {
  A = "A",
  B = "B",
  C = "C",
}

/* Template custom: data-contract-jsdoc */
export enum ApiClarityType {
  Flawless = "flawless",
  InternallyFlawless = "internallyFlawless",
  VVS1 = "VVS1",
  VVS2 = "VVS2",
  VS1 = "VS1",
  VS2 = "VS2",
  S1 = "S1",
  S2 = "S2",
  I1 = "I1",
  I2 = "I2",
  I3 = "I3",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiCategoryType {
  A = "a",
  A1 = "a1",
  B = "b",
  B1 = "b1",
  C = "c",
  C1 = "c1",
  D = "d",
  D1 = "d1",
  Be = "be",
  Ce = "ce",
  De = "de",
  C1E = "c1e",
  D1E = "d1e",
  M = "m",
  Tm = "tm",
  Tb = "tb",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBondsEnum {
  Corporate = "corporate",
  Municipal = "municipal",
  Sovereign = "sovereign",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBondType {
  Classic = "classic",
  Secure = "secure",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBasisType {
  Rental = "rental",
  Ownership = "ownership",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBasisOfObtainingType {
  OpeningACompany = "openingACompany",
  Employment = "employment",
  Studies = "studies",
  Marriage = "marriage",
  BuyingRealEstate = "buyingRealEstate",
  MedicalTreatment = "medicalTreatment",
  FamilyReunification = "familyReunification",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBasicAssetType {
  Stocks = "stocks",
  Commodity = "commodity",
  Equity = "equity",
  Currency = "currency",
  Index = "index",
  InterestRate = "interestRate",
  FuturesContract = "futuresContract",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBaseAssetType {
  Aluminium = "aluminium",
  ChemicalProducts = "Chemical products",
  Diamonds = "Diamonds",
  Gold = "Gold",
  Grain = "Grain",
  RealEstate = "realEstate",
  IndustrialMetals = "Industrial metals",
  Iridium = "Iridium",
  Lumber = "Lumber",
  MineralProducts = "Mineral products",
  Nickel = "nickel",
  NonFerrousMetals = "Non-ferrous metals",
  Palladium = "Palladium",
  Petroleum = "Petroleum",
  PetroleumProducts = "Petroleum products",
  Platinum = "Platinum",
  RareEarthMetals = "Rare earth metals",
  Rhodium = "Rhodium",
  Ruthenium = "Ruthenium",
  RawMaterial = "Raw material",
  Lead = "Lead",
  Zinc = "Zinc",
  Other = "other",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBankCellType {
  Standard = "standard",
  Safekeeping = "safekeeping",
}

/* Template custom: data-contract-jsdoc */
export enum ApiBankCellAccessMethod {
  Keys = "keys",
  Code = "code",
  Fingerprint = "fingerprint",
  Retina = "retina",
}

/* Template custom: data-contract-jsdoc */
export enum ApiAssetCategory {
  DEBIT_ACCOUNTS = "DEBIT_ACCOUNTS",
  RESIDENTIAL_REAL_ESTATE = "RESIDENTIAL_REAL_ESTATE",
  COMMERCIAL_REAL_ESTATE = "COMMERCIAL_REAL_ESTATE",
  LAND = "LAND",
  LEGAL_ENTITIES = "LEGAL_ENTITIES",
  JEWELLERY = "JEWELLERY",
  BANK_CELLS = "BANK_CELLS",
  METAL_ACCOUNTS = "METAL_ACCOUNTS",
  CENTRALIZED_WALLET = "CENTRALIZED_WALLET",
  DECENTRALIZED_WALLET = "DECENTRALIZED_WALLET",
  PRECIOUS_STONES = "PRECIOUS_STONES",
  COMMODITY_ASSET_TOKENS = "COMMODITY_ASSET_TOKENS",
  BROKERAGE_ACCOUNT = "BROKERAGE_ACCOUNT",
  SECURITIES_AND_STOCKS = "SECURITIES_AND_STOCKS",
  BONDS = "BONDS",
  EXCHANGE_OPTIONS = "EXCHANGE_OPTIONS",
  OVER_THE_COUNTER_OPTIONS = "OVER_THE_COUNTER_OPTIONS",
  FORWARDS = "FORWARDS",
  FUTURES = "FUTURES",
  MY_FUND = "MY_FUND",
  PUBLIC_FUND = "PUBLIC_FUND",
}

/* Template custom: data-contract-jsdoc */
export enum ApiAppraisalLaboratoryType {
  GIA = "GIA",
  HRD = "HRD",
  IGI = "IGI",
  EGL = "EGL",
  GAGLT = "GAGLT",
  ISDI = "ISDI",
  INDI = "INDI",
}

/* Template custom: data-contract-jsdoc */
export enum ApiActivityType {
  Active = "active",
  Passive = "passive",
}

/* Template custom: data-contract-jsdoc */
export interface ApiRootResponse {
  /* Template custom: data-contract-jsdoc */
  message: string;
  /* Template custom: data-contract-jsdoc */
  minSupportedClientVersion: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyHttpResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  title: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMainUserPublickKeyResponse {
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiProfileResponseWithMainUserKey {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  userName?: string | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  avatarUrl?: string | null;
  /* Template custom: data-contract-jsdoc */
  bio?: string | null;
  /* Template custom: data-contract-jsdoc */
  invitationLastSentTime?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastActivityAt: string;
  /* Template custom: data-contract-jsdoc */
  mainUserId?: number | null;
  /* Template custom: data-contract-jsdoc */
  ocrSuppressLetsTryConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  publicKey?: string | null;
  /* Template custom: data-contract-jsdoc */
  roles: string[];
  /* Template custom: data-contract-jsdoc */
  soweAppendixSuppressCancelConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  totpEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  totpSecret?: string | null;
  /* Template custom: data-contract-jsdoc */
  encryptionTypeId?: number | null;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestionsEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  type: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  baseCurrencyId: number;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  beneficiaryCollectionItemId?: string | null;
  /* Template custom: data-contract-jsdoc */
  baseCurrency?: ApiCurrencyHttpResponse;
  /* Template custom: data-contract-jsdoc */
  mainUser?: ApiMainUserPublickKeyResponse;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccountSessionResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  accountId: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  expiresAt: string;
  /* Template custom: data-contract-jsdoc */
  ipAddr: string;
  /* Template custom: data-contract-jsdoc */
  token: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  userAgent?: string | null;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  status: "ACTIVE" | "NOT_ACTIVE";
  /* Template custom: data-contract-jsdoc */
  plan?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateStart: string;
  /* Template custom: data-contract-jsdoc */
  dateEnd: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  profile?: object | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccountSessionSubscriptionResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  phone?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  confirmedPhone?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  schemaVersion: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  profile?: ApiProfileResponseWithMainUserKey | null;
  /* Template custom: data-contract-jsdoc */
  sessions: ApiAccountSessionResponse[];
  /* Template custom: data-contract-jsdoc */
  subscription?: ApiSubscriptionDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccessStatusesHttpResponse {
  /* Template custom: data-contract-jsdoc */
  accountAvailabilityApp: boolean;
  /* Template custom: data-contract-jsdoc */
  availabilityMyHub: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiEmailCodeDto {
  /* Template custom: data-contract-jsdoc */
  emailCode: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccountPasswordDto {
  /* Template custom: data-contract-jsdoc */
  password: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateAccountSchemaVersionDto {
  /* Template custom: data-contract-jsdoc */
  schemaVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiLoginDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
  /* Template custom: data-contract-jsdoc */
  invitationToken?: string;
  /* Template custom: data-contract-jsdoc */
  referralCode?: string;
  /* Template custom: data-contract-jsdoc */
  requestEmailVerification?: boolean;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccountResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  phone?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  confirmedPhone?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  schemaVersion: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  profile?: ApiProfileResponseWithMainUserKey | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthHttpResponse {
  /* Template custom: data-contract-jsdoc */
  token: string;
  /* Template custom: data-contract-jsdoc */
  account: ApiAccountResponse;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateWillParticipationDto {
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  role: "EXECUTOR" | "WITNESS" | "INFORMATION_RECIPIENT" | "BENEFICIARY";
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateBeneficiaryDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  dontSendInviteEmail: boolean | null;
  /* Template custom: data-contract-jsdoc */
  isAnonymous: boolean | null;
  /* Template custom: data-contract-jsdoc */
  anonymousId?: string | null;
  /* Template custom: data-contract-jsdoc */
  willParticipation?: ApiCreateWillParticipationDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateBeneficiaryHttpResponse {
  /* Template custom: data-contract-jsdoc */
  account: ApiAccountResponse;
  /* Template custom: data-contract-jsdoc */
  invitationCode: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthBeneficiaryDto {
  /* Template custom: data-contract-jsdoc */
  beneficiaryProfileId: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateAssistantDto {
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
  /* Template custom: data-contract-jsdoc */
  name: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiProfileResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  userName?: string | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  avatarUrl?: string | null;
  /* Template custom: data-contract-jsdoc */
  bio?: string | null;
  /* Template custom: data-contract-jsdoc */
  invitationLastSentTime?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastActivityAt: string;
  /* Template custom: data-contract-jsdoc */
  mainUserId?: number | null;
  /* Template custom: data-contract-jsdoc */
  ocrSuppressLetsTryConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  publicKey?: string | null;
  /* Template custom: data-contract-jsdoc */
  roles: string[];
  /* Template custom: data-contract-jsdoc */
  soweAppendixSuppressCancelConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  totpEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  totpSecret?: string | null;
  /* Template custom: data-contract-jsdoc */
  encryptionTypeId?: number | null;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestionsEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  type: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  baseCurrencyId: number;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  beneficiaryCollectionItemId?: string | null;
  /* Template custom: data-contract-jsdoc */
  baseCurrency?: ApiCurrencyHttpResponse;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateTwoFactorQuestionDto {
  /* Template custom: data-contract-jsdoc */
  answer: string;
  /* Template custom: data-contract-jsdoc */
  question: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBeneficiaryActivationCreate {
  /* Template custom: data-contract-jsdoc */
  jwt: string;
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestions?: ApiCreateTwoFactorQuestionDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiProfileStatusResponse {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  status: "CREATED" | "INACTIVE" | "ACTIVE" | "DELETED";
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthPublicKeyDto {
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthJwtDto {
  /* Template custom: data-contract-jsdoc */
  jwt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthCodeDto {
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthLogoutDto {
  /* Template custom: data-contract-jsdoc */
  sessionIds?: number[] | null;
  /* Template custom: data-contract-jsdoc */
  token?: string | null;
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiChangePasswordDto {
  /* Template custom: data-contract-jsdoc */
  oldPassword: string;
  /* Template custom: data-contract-jsdoc */
  newPassword: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateGenerateEmailCode {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  typeEmailCode: "DELETE" | "CREATE";
}

/* Template custom: data-contract-jsdoc */
export interface ApiGenerateEmailHttpCodeResponse {
  /* Template custom: data-contract-jsdoc */
  result: boolean;
  /* Template custom: data-contract-jsdoc */
  expiresAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateActiveAccount {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  code: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateResetPassword {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  emailCode: string;
  /* Template custom: data-contract-jsdoc */
  newPassword: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthEmailDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiResetPasswordCodeDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  newPassword: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateBeneficiaryCreateByInviteCode {
  /* Template custom: data-contract-jsdoc */
  invitationCode: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestions?: ApiCreateTwoFactorQuestionDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiPushTokenDto {
  /* Template custom: data-contract-jsdoc */
  authToken: string;
  /* Template custom: data-contract-jsdoc */
  pushToken: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiProfileSimpleResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  userName?: string | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  avatarUrl?: string | null;
  /* Template custom: data-contract-jsdoc */
  bio?: string | null;
  /* Template custom: data-contract-jsdoc */
  invitationLastSentTime?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastActivityAt: string;
  /* Template custom: data-contract-jsdoc */
  mainUserId?: number | null;
  /* Template custom: data-contract-jsdoc */
  ocrSuppressLetsTryConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  publicKey?: string | null;
  /* Template custom: data-contract-jsdoc */
  roles: ("ADMIN" | "USER")[];
  /* Template custom: data-contract-jsdoc */
  soweAppendixSuppressCancelConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  status: "CREATED" | "INACTIVE" | "ACTIVE" | "DELETED";
  /* Template custom: data-contract-jsdoc */
  totpEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  totpSecret?: string | null;
  /* Template custom: data-contract-jsdoc */
  encryptionTypeId?: number | null;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestionsEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  type: "MAIN_USER" | "BENEFICIARY" | "ASSISTANT";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  baseCurrencyId: number;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  beneficiaryCollectionItemId?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiProfileWithMainUserResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  userName?: string | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  avatarUrl?: string | null;
  /* Template custom: data-contract-jsdoc */
  bio?: string | null;
  /* Template custom: data-contract-jsdoc */
  invitationLastSentTime?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastActivityAt: string;
  /* Template custom: data-contract-jsdoc */
  mainUserId?: number | null;
  /* Template custom: data-contract-jsdoc */
  ocrSuppressLetsTryConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  publicKey?: string | null;
  /* Template custom: data-contract-jsdoc */
  roles: ("ADMIN" | "USER")[];
  /* Template custom: data-contract-jsdoc */
  soweAppendixSuppressCancelConfirmation: boolean;
  /* Template custom: data-contract-jsdoc */
  status: "CREATED" | "INACTIVE" | "ACTIVE" | "DELETED";
  /* Template custom: data-contract-jsdoc */
  totpEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  totpSecret?: string | null;
  /* Template custom: data-contract-jsdoc */
  encryptionTypeId?: number | null;
  /* Template custom: data-contract-jsdoc */
  twoFactorQuestionsEnabled: boolean;
  /* Template custom: data-contract-jsdoc */
  type: "MAIN_USER" | "BENEFICIARY" | "ASSISTANT";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  baseCurrencyId: number;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  beneficiaryCollectionItemId?: string | null;
  /* Template custom: data-contract-jsdoc */
  mainUser?: ApiProfileSimpleResponse | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateProfileDto {
  /* Template custom: data-contract-jsdoc */
  firstName?: string;
  /* Template custom: data-contract-jsdoc */
  lastName?: string;
  /* Template custom: data-contract-jsdoc */
  userName?: string;
  /* Template custom: data-contract-jsdoc */
  bio?: string;
  /* Template custom: data-contract-jsdoc */
  avatarUrl?: string;
  /* Template custom: data-contract-jsdoc */
  soweAppendixSuppressCancelConfirmation?: boolean;
  /* Template custom: data-contract-jsdoc */
  ocrSuppressLetsTryConfirmation?: boolean;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAccountSimpleResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  phone?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  confirmedPhone?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  schemaVersion: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateBeneficiaryCollectionItemIdDto {
  /* Template custom: data-contract-jsdoc */
  beneficiaryCollectionItemId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateCurrencyProfileDto {
  /* Template custom: data-contract-jsdoc */
  baseCurrency:
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "ANG"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AWG"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BMD"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTC"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BYR"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLF"
    | "CLP"
    | "CNH"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "FKP"
    | "GBP"
    | "GEL"
    | "GGP"
    | "GHS"
    | "GIP"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "IMP"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JEP"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KPW"
    | "KRW"
    | "KWD"
    | "KYD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LTL"
    | "LVL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MOP"
    | "MRU"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RUB"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SHP"
    | "SLE"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STD"
    | "SYP"
    | "SVC"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XCD"
    | "XDR"
    | "XOF"
    | "XPF"
    | "YER"
    | "ZAR"
    | "ZMK"
    | "ZMW"
    | "ZWL";
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionStatusResponse {
  /* Template custom: data-contract-jsdoc */
  status: "ACTIVE" | "NOT_ACTIVE";
  /* Template custom: data-contract-jsdoc */
  plan?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiErrorResponseDto {
  /* Template custom: data-contract-jsdoc */
  errorCode: string;
  /* Template custom: data-contract-jsdoc */
  message: string;
  /* Template custom: data-contract-jsdoc */
  details?: string[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyReceiptDto {
  /* Template custom: data-contract-jsdoc */
  originalTransactionId: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  bundleId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyReceiptResponse {
  /* Template custom: data-contract-jsdoc */
  transactionId: string;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId: string;
  /* Template custom: data-contract-jsdoc */
  bundleId: string;
  /* Template custom: data-contract-jsdoc */
  productId: string;
  /* Template custom: data-contract-jsdoc */
  purchaseDate: string;
  /* Template custom: data-contract-jsdoc */
  originalPurchaseDate: string;
  /* Template custom: data-contract-jsdoc */
  quantity: number;
  /* Template custom: data-contract-jsdoc */
  type:
    | "Auto-Renewable Subscription"
    | "Non-Consumable"
    | "Consumable"
    | "Non-Renewing Subscription";
  /* Template custom: data-contract-jsdoc */
  inAppOwnershipType: "PURCHASED";
  /* Template custom: data-contract-jsdoc */
  signedDate: string;
  /* Template custom: data-contract-jsdoc */
  environment: "Sandbox" | "Production";
  /* Template custom: data-contract-jsdoc */
  transactionReason: "PURCHASE";
  /* Template custom: data-contract-jsdoc */
  storefront: string;
  /* Template custom: data-contract-jsdoc */
  storefrontId: string;
  /* Template custom: data-contract-jsdoc */
  price: number;
  /* Template custom: data-contract-jsdoc */
  currency: string;
  /* Template custom: data-contract-jsdoc */
  appTransactionId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPushCollectionDto {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  data: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCollectionDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  data: string;
  /* Template custom: data-contract-jsdoc */
  ver: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiEncryptedSymmetricKeysDto {
  /* Template custom: data-contract-jsdoc */
  __dataType: string;
  /* Template custom: data-contract-jsdoc */
  value: string[][];
}

/* Template custom: data-contract-jsdoc */
export interface ApiPermissionsDto {
  /* Template custom: data-contract-jsdoc */
  __dataType: string;
  /* Template custom: data-contract-jsdoc */
  value: (string | ApiPermissionSetDto)[][];
}

/* Template custom: data-contract-jsdoc */
export interface ApiPermissionSetDto {
  /* Template custom: data-contract-jsdoc */
  __dataType: string;
  /* Template custom: data-contract-jsdoc */
  value: string[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiItemDto {
  /* Template custom: data-contract-jsdoc */
  encryptedData: string;
  /* Template custom: data-contract-jsdoc */
  encryptedSymmetricKeys: ApiEncryptedSymmetricKeysDto;
  /* Template custom: data-contract-jsdoc */
  permissions: ApiPermissionsDto;
  /* Template custom: data-contract-jsdoc */
  signature: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddItemToCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  item: ApiItemDto;
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddItemToCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  item: ApiItemDto;
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiChangeItemInCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature?: string;
  /* Template custom: data-contract-jsdoc */
  item: ApiItemDto;
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiChangeItemInCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  item: ApiItemDto;
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveItemInCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature?: string;
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveItemInCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveItemsDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveItemsFromCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  items: ApiRemoveItemsDto[];
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveItemsFromCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  removedDtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiItemsDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  item: ApiItemDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddItemsToCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  items: ApiItemsDto[];
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddItemsToCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  addedItems: ApiItemsDto[];
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateItemsInCollectionRequestDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  items: ApiItemsDto[];
  /* Template custom: data-contract-jsdoc */
  platform?: "ANDROID" | "IOS" | "WEB" | "BACKEND";
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateItemsInCollectionResponseDto {
  /* Template custom: data-contract-jsdoc */
  collectionName:
    | "assets"
    | "sowe"
    | "soweAttachments"
    | "encryptedFileKey"
    | "beneficiaries"
    | "delegatingRequests"
    | "contacts"
    | "contactEntities"
    | "fileMetaInfos"
    | "scenarioMetaInfos"
    | "beneficiaryPersonalDataDocuments"
    | "assetInformationDocument"
    | "privateDocuments"
    | "personalIdentifiersDocuments"
    | "assistantMnemonic"
    | "notification"
    | "inbox"
    | "myHub"
    | "interwills"
    | "forms"
    | "formQuestionGroups"
    | "formQuestions"
    | "formQuestionOptions"
    | "formResponses"
    | "formQuestionResponses"
    | "passportDocuments"
    | "unknownDocuments"
    | "soweAttachedPersonalIdentifier"
    | "migrations";
  /* Template custom: data-contract-jsdoc */
  updatedItems: ApiItemsDto[];
  /* Template custom: data-contract-jsdoc */
  collectionVersion: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAttacmentsInboxDto {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  extension: string;
  /* Template custom: data-contract-jsdoc */
  comment: string;
  /* Template custom: data-contract-jsdoc */
  encryptedSymmetricKey: string;
  /* Template custom: data-contract-jsdoc */
  createdAt?: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAttachmentsInboxRequestDto {
  /* Template custom: data-contract-jsdoc */
  attachments: ApiAttacmentsInboxDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateManyCollectionsRequestDto {
  /* Template custom: data-contract-jsdoc */
  collections: ApiUpdateItemsInCollectionRequestDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateManyCollectionsResponseDto {
  /* Template custom: data-contract-jsdoc */
  collections: ApiUpdateItemsInCollectionResponseDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateFileStorageHttpDto {
  /* Template custom: data-contract-jsdoc */
  fileContent: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateWillDto {
  /* Template custom: data-contract-jsdoc */
  scenarioId?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWillParticipantResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  role: "BENEFICIARY" | "WITNESS" | "EXECUTOR" | "INFORMATION_RECIPIENT";
  /* Template custom: data-contract-jsdoc */
  status: "INVITED" | "ACCEPTED" | "DECLINED" | "SIGNED";
  /* Template custom: data-contract-jsdoc */
  invitedAt: string;
  /* Template custom: data-contract-jsdoc */
  acceptedAt?: string;
  /* Template custom: data-contract-jsdoc */
  signedAt?: string;
  /* Template custom: data-contract-jsdoc */
  profile: ApiProfileResponse;
  /* Template custom: data-contract-jsdoc */
  asInformationRecipient?: object[];
  /* Template custom: data-contract-jsdoc */
  asBeneficiaryWithRecipient?: object[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiWillAttachmentResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  attachmentNumber: string;
  /* Template custom: data-contract-jsdoc */
  type: "VIDEO" | "DOCUMENT" | "ASSET_LIST" | "COMMENT";
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
  /* Template custom: data-contract-jsdoc */
  certificateId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  metadata?: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWillResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  willNumber: string;
  /* Template custom: data-contract-jsdoc */
  status: "DRAFT" | "PENDING_SIGNATURES" | "SIGNED" | "EXECUTED";
  /* Template custom: data-contract-jsdoc */
  creatorId: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  creator: ApiProfileResponse;
  /* Template custom: data-contract-jsdoc */
  participants: ApiWillParticipantResponse[];
  /* Template custom: data-contract-jsdoc */
  attachments: ApiWillAttachmentResponse[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateWillParticipantDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  role:
    | "BENEFICIARY"
    | "WITNESS"
    | "EXECUTOR"
    | "ALTERNATIVE_EXECUTOR"
    | "INFORMATION_RECIPIENT";
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateWillAttachmentDto {
  /* Template custom: data-contract-jsdoc */
  type: "VIDEO" | "DOCUMENT" | "ASSET_LIST" | "COMMENT";
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
  /* Template custom: data-contract-jsdoc */
  certificateId?: string;
  /* Template custom: data-contract-jsdoc */
  metadata?: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateWillAttachmentDto {
  /* Template custom: data-contract-jsdoc */
  type?: "VIDEO" | "DOCUMENT" | "ASSET_LIST" | "COMMENT";
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
  /* Template custom: data-contract-jsdoc */
  certificateId?: string;
  /* Template custom: data-contract-jsdoc */
  metadata?: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAttachScenarioDto {
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateRegionNameDto {
  /* Template custom: data-contract-jsdoc */
  regionCode: string;
  /* Template custom: data-contract-jsdoc */
  regionName: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRegionNameResponseDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  regionCode: string;
  /* Template custom: data-contract-jsdoc */
  regionName: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateRegionNameDto {
  /* Template custom: data-contract-jsdoc */
  regionCode?: string;
  /* Template custom: data-contract-jsdoc */
  regionName?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateScenarioHttpDto {
  /* Template custom: data-contract-jsdoc */
  beneficiaryProfileId: number;
  /* Template custom: data-contract-jsdoc */
  triggerValue: string;
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  triggerType: "AFTER_DATETIME" | "AFTER_INACTIVITY";
  /* Template custom: data-contract-jsdoc */
  mode?: "NORMAL" | "TEST";
  /* Template custom: data-contract-jsdoc */
  notificationValue: string;
  /* Template custom: data-contract-jsdoc */
  notificationPeriod: string;
  /* Template custom: data-contract-jsdoc */
  notificationTime: string;
  /* Template custom: data-contract-jsdoc */
  isViewed: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateScenarioDto {
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  testDtoIds?: string[];
  /* Template custom: data-contract-jsdoc */
  triggers?: ApiTriggersDto;
  /* Template custom: data-contract-jsdoc */
  triggerCondition?: "1" | "2" | "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  transferCondition?: "1" | "2" | "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  notificationSettings?: ApiNotificationSettingsDto;
  /* Template custom: data-contract-jsdoc */
  notifications?: ApiNotificationDto[];
  /* Template custom: data-contract-jsdoc */
  transfers?: ApiTransferDto[];
  /* Template custom: data-contract-jsdoc */
  permissions?: number[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiLegacyScenarioResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  beneficiary?: ApiProfileResponse;
  /* Template custom: data-contract-jsdoc */
  beneficiaryId: number;
  /* Template custom: data-contract-jsdoc */
  currentNotificationValue: string;
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  triggerValue: string;
  /* Template custom: data-contract-jsdoc */
  notificationValue: string;
  /* Template custom: data-contract-jsdoc */
  notificationPeriod: string;
  /* Template custom: data-contract-jsdoc */
  mainUser?: ApiProfileResponse;
  /* Template custom: data-contract-jsdoc */
  mainUserId: number;
  /* Template custom: data-contract-jsdoc */
  mode: "NORMAL" | "TEST";
  /* Template custom: data-contract-jsdoc */
  notificationTime: string;
  /* Template custom: data-contract-jsdoc */
  status: "DRAFT" | "ACTIVE" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  triggerType: "AFTER_DATETIME" | "AFTER_INACTIVITY";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  isViewed: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyMemberScenarioResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  mode: "NORMAL" | "TEST";
  /* Template custom: data-contract-jsdoc */
  status: "DRAFT" | "ACTIVE" | "IN_PROGRESS" | "DONE" | "CANCELLED";
}

/* Template custom: data-contract-jsdoc */
export interface ApiMailBoxesResponseDto {
  /* Template custom: data-contract-jsdoc */
  domain: string;
  /* Template custom: data-contract-jsdoc */
  username: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGetMailBoxResponseDto {
  /* Template custom: data-contract-jsdoc */
  mailbox: ApiMailBoxesResponseDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTakenDto {
  /* Template custom: data-contract-jsdoc */
  isTaken: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateMailboxDto {
  /* Template custom: data-contract-jsdoc */
  username: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
  /* Template custom: data-contract-jsdoc */
  domain: string;
  /* Template custom: data-contract-jsdoc */
  profileId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrentMailBoxDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateHubDto {
  /* Template custom: data-contract-jsdoc */
  basicAuthLogin: string;
  /* Template custom: data-contract-jsdoc */
  basicAuthPassword: string;
  /* Template custom: data-contract-jsdoc */
  hubType?: "INNER" | "EXTERNAL" | "MOVED";
  /* Template custom: data-contract-jsdoc */
  awsAccessKeyId?: string;
  /* Template custom: data-contract-jsdoc */
  awsSecretAccessKey?: string;
  /* Template custom: data-contract-jsdoc */
  provider?: "AWS" | "Yandex" | "Alibaba";
  /* Template custom: data-contract-jsdoc */
  regionId?: number;
  /* Template custom: data-contract-jsdoc */
  idInnerHub?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSafeExportResponseDto {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  url: string;
  /* Template custom: data-contract-jsdoc */
  hubType: string;
  /* Template custom: data-contract-jsdoc */
  status: string;
}

/* Template custom: data-contract-jsdoc */
export type ApiAddFieldsDto = object;

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyRateDto {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  currencyCode: string;
  /* Template custom: data-contract-jsdoc */
  value: number;
  /* Template custom: data-contract-jsdoc */
  baseCurrency: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyDto {
  /* Template custom: data-contract-jsdoc */
  baseCurrency:
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "ANG"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AWG"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BMD"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTC"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BYR"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLF"
    | "CLP"
    | "CNH"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "FKP"
    | "GBP"
    | "GEL"
    | "GGP"
    | "GHS"
    | "GIP"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "IMP"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JEP"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KPW"
    | "KRW"
    | "KWD"
    | "KYD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LTL"
    | "LVL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MOP"
    | "MRU"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RUB"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SHP"
    | "SLE"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STD"
    | "SYP"
    | "SVC"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XCD"
    | "XDR"
    | "XOF"
    | "XPF"
    | "YER"
    | "ZAR"
    | "ZMK"
    | "ZMW"
    | "ZWL";
  /* Template custom: data-contract-jsdoc */
  quoteCurrencies?:
    | "AED"
    | "AFN"
    | "ALL"
    | "AMD"
    | "ANG"
    | "AOA"
    | "ARS"
    | "AUD"
    | "AWG"
    | "AZN"
    | "BAM"
    | "BBD"
    | "BDT"
    | "BGN"
    | "BHD"
    | "BIF"
    | "BMD"
    | "BND"
    | "BOB"
    | "BRL"
    | "BSD"
    | "BTC"
    | "BTN"
    | "BWP"
    | "BYN"
    | "BYR"
    | "BZD"
    | "CAD"
    | "CDF"
    | "CHF"
    | "CLF"
    | "CLP"
    | "CNH"
    | "CNY"
    | "COP"
    | "CRC"
    | "CUC"
    | "CUP"
    | "CVE"
    | "CZK"
    | "DJF"
    | "DKK"
    | "DOP"
    | "DZD"
    | "EGP"
    | "ERN"
    | "ETB"
    | "EUR"
    | "FJD"
    | "FKP"
    | "GBP"
    | "GEL"
    | "GGP"
    | "GHS"
    | "GIP"
    | "GMD"
    | "GNF"
    | "GTQ"
    | "GYD"
    | "HKD"
    | "HNL"
    | "HRK"
    | "HTG"
    | "HUF"
    | "IDR"
    | "ILS"
    | "IMP"
    | "INR"
    | "IQD"
    | "IRR"
    | "ISK"
    | "JEP"
    | "JMD"
    | "JOD"
    | "JPY"
    | "KES"
    | "KGS"
    | "KHR"
    | "KMF"
    | "KPW"
    | "KRW"
    | "KWD"
    | "KYD"
    | "KZT"
    | "LAK"
    | "LBP"
    | "LKR"
    | "LRD"
    | "LSL"
    | "LTL"
    | "LVL"
    | "LYD"
    | "MAD"
    | "MDL"
    | "MGA"
    | "MKD"
    | "MMK"
    | "MNT"
    | "MOP"
    | "MRU"
    | "MUR"
    | "MVR"
    | "MWK"
    | "MXN"
    | "MYR"
    | "MZN"
    | "NAD"
    | "NGN"
    | "NIO"
    | "NOK"
    | "NPR"
    | "NZD"
    | "OMR"
    | "PAB"
    | "PEN"
    | "PGK"
    | "PHP"
    | "PKR"
    | "PLN"
    | "PYG"
    | "QAR"
    | "RON"
    | "RSD"
    | "RUB"
    | "RWF"
    | "SAR"
    | "SBD"
    | "SCR"
    | "SDG"
    | "SEK"
    | "SGD"
    | "SHP"
    | "SLE"
    | "SLL"
    | "SOS"
    | "SRD"
    | "STD"
    | "SYP"
    | "SVC"
    | "SZL"
    | "THB"
    | "TJS"
    | "TMT"
    | "TND"
    | "TOP"
    | "TRY"
    | "TTD"
    | "TWD"
    | "TZS"
    | "UAH"
    | "UGX"
    | "USD"
    | "UYU"
    | "UZS"
    | "VES"
    | "VND"
    | "VUV"
    | "WST"
    | "XAF"
    | "XAG"
    | "XAU"
    | "XCD"
    | "XDR"
    | "XOF"
    | "XPF"
    | "YER"
    | "ZAR"
    | "ZMK"
    | "ZMW"
    | "ZWL";
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyRateBaseDto {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  quoteCurrency: string;
  /* Template custom: data-contract-jsdoc */
  rate: number;
  /* Template custom: data-contract-jsdoc */
  baseCurrency: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiHubSettingsResponseDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  hubActive: boolean;
  /* Template custom: data-contract-jsdoc */
  updatingHub: boolean;
  /* Template custom: data-contract-jsdoc */
  ownedByUser: boolean;
  /* Template custom: data-contract-jsdoc */
  abilityToDisconnect: boolean;
  /* Template custom: data-contract-jsdoc */
  ipAddress: string;
  /* Template custom: data-contract-jsdoc */
  provider: string;
  /* Template custom: data-contract-jsdoc */
  country: string;
  /* Template custom: data-contract-jsdoc */
  connectedAt: string;
  /* Template custom: data-contract-jsdoc */
  lastPingAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  hubUrl: string;
  /* Template custom: data-contract-jsdoc */
  isDoubleMirror: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGetHubSettingsByUrlDto {
  /* Template custom: data-contract-jsdoc */
  url: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAuthResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  uuid: string;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  emailVerifiedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  language: string;
  /* Template custom: data-contract-jsdoc */
  accessToken: string;
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAnalyticsDto {
  /* Template custom: data-contract-jsdoc */
  marketing?: boolean;
  /* Template custom: data-contract-jsdoc */
  age?: string;
  /* Template custom: data-contract-jsdoc */
  residenceCountry?: string;
  /* Template custom: data-contract-jsdoc */
  citizenshipsNumber?: string;
  /* Template custom: data-contract-jsdoc */
  assetsCountriesNumber?: string;
  /* Template custom: data-contract-jsdoc */
  kids?: string;
  /* Template custom: data-contract-jsdoc */
  showroomSlug?: string;
  /* Template custom: data-contract-jsdoc */
  utmCampaign?: string;
  /* Template custom: data-contract-jsdoc */
  utmMedium?: string;
  /* Template custom: data-contract-jsdoc */
  utmSource?: string;
  /* Template custom: data-contract-jsdoc */
  utmContent?: string;
  /* Template custom: data-contract-jsdoc */
  utmTerm?: string;
  /* Template custom: data-contract-jsdoc */
  registrationCampaign?: string;
  /* Template custom: data-contract-jsdoc */
  registrationMedium?: string;
  /* Template custom: data-contract-jsdoc */
  registrationSource?: string;
  /* Template custom: data-contract-jsdoc */
  registrationContent?: string;
  /* Template custom: data-contract-jsdoc */
  registrationTerm?: string;
  /* Template custom: data-contract-jsdoc */
  firstTouchCampaign?: string;
  /* Template custom: data-contract-jsdoc */
  firstTouchMedium?: string;
  /* Template custom: data-contract-jsdoc */
  firstTouchSource?: string;
  /* Template custom: data-contract-jsdoc */
  firstTouchContent?: string;
  /* Template custom: data-contract-jsdoc */
  firstTouchTerm?: string;
  /* Template custom: data-contract-jsdoc */
  lastTouchCampaign?: string;
  /* Template custom: data-contract-jsdoc */
  lastTouchMedium?: string;
  /* Template custom: data-contract-jsdoc */
  lastTouchSource?: string;
  /* Template custom: data-contract-jsdoc */
  lastTouchContent?: string;
  /* Template custom: data-contract-jsdoc */
  lastTouchTerm?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRegisterDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
  /* Template custom: data-contract-jsdoc */
  firstName?: string;
  /* Template custom: data-contract-jsdoc */
  lastName?: string;
  /* Template custom: data-contract-jsdoc */
  language?: string;
  /* Template custom: data-contract-jsdoc */
  analytics?: ApiAnalyticsDto;
  /* Template custom: data-contract-jsdoc */
  invitationToken?: string;
  /* Template custom: data-contract-jsdoc */
  referralCode?: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSuccessResponse {
  /* Template custom: data-contract-jsdoc */
  success: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRefreshTokenDto {
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRefreshResponse {
  /* Template custom: data-contract-jsdoc */
  accessToken: string;
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiLogoutAllResponse {
  /* Template custom: data-contract-jsdoc */
  count: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRequestEmailVerificationDto {
  /* Template custom: data-contract-jsdoc */
  verificationType?: "code" | "link";
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyEmailByOtpDto {
  /* Template custom: data-contract-jsdoc */
  otpCode: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyEmailDto {
  /* Template custom: data-contract-jsdoc */
  token: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRequestPasswordResetDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiResetPasswordDto {
  /* Template custom: data-contract-jsdoc */
  token: string;
  /* Template custom: data-contract-jsdoc */
  password: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiLegacyTokenDto {
  /* Template custom: data-contract-jsdoc */
  legacyToken: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssistantPublicKeyDto {
  /* Template custom: data-contract-jsdoc */
  publicKey: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssistantEncryptedMessageResponse {
  /* Template custom: data-contract-jsdoc */
  encryptedMessage: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssistantLoginChallengeJwtDto {
  /* Template custom: data-contract-jsdoc */
  challengeJwt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssistantAuthResponse {
  /* Template custom: data-contract-jsdoc */
  accessToken: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGoogleVerifyCodeDto {
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  analytics?: ApiAnalyticsDto;
  /* Template custom: data-contract-jsdoc */
  invitationToken?: string;
  /* Template custom: data-contract-jsdoc */
  referralCode?: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGoogleVerifyDto {
  /* Template custom: data-contract-jsdoc */
  idToken: string;
  /* Template custom: data-contract-jsdoc */
  analytics?: ApiAnalyticsDto;
  /* Template custom: data-contract-jsdoc */
  invitationToken?: string;
  /* Template custom: data-contract-jsdoc */
  referralCode?: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSetMarketingDto {
  /* Template custom: data-contract-jsdoc */
  notificationsEnabled: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSetPushSettingsDto {
  /* Template custom: data-contract-jsdoc */
  allowMobilePush: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrentUserResponse {
  /* Template custom: data-contract-jsdoc */
  uuid: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  emailVerifiedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  language?: string;
  /* Template custom: data-contract-jsdoc */
  marketingAgreedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  allowMobilePush: boolean;
  /* Template custom: data-contract-jsdoc */
  hasCompletedOnboarding: boolean;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  isPaymentEligible: boolean;
  /* Template custom: data-contract-jsdoc */
  referralCodesAvailable: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateUserDto {
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateFcmTokenDto {
  /* Template custom: data-contract-jsdoc */
  refreshToken: string;
  /* Template custom: data-contract-jsdoc */
  fcmToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiApplyReferralCodeDto {
  /* Template custom: data-contract-jsdoc */
  referralCode: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiReferralCodeResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  status: "NOT_APPLIED" | "APPLIED" | "EXPIRED";
  /* Template custom: data-contract-jsdoc */
  recipientEmail?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  expiresAt?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateReferralCodeDto {
  /* Template custom: data-contract-jsdoc */
  recipientEmail: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSendReferralCodeEmailDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  language?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCanRequestSystemCodeResponse {
  /* Template custom: data-contract-jsdoc */
  canRequestSystemCode: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiQuestionnaireAnswerDto {
  /* Template custom: data-contract-jsdoc */
  answerId: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateSystemCodeRequestDto {
  /* Template custom: data-contract-jsdoc */
  answers: ApiQuestionnaireAnswerDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiSystemCodeRequestAnswerResponse {
  /* Template custom: data-contract-jsdoc */
  question: string;
  /* Template custom: data-contract-jsdoc */
  answer: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSystemCodeRequestResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  result?: "APPROVE" | "REJECT" | null;
  /* Template custom: data-contract-jsdoc */
  answers: ApiSystemCodeRequestAnswerResponse[];
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiScopeResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  tenantProfileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  scopeType: "VFO" | "INTERWILL" | "REPOSITORY";
  /* Template custom: data-contract-jsdoc */
  tag?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTenantProfileResponse {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  tag?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateScopeDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  scopeType: "VFO" | "INTERWILL" | "REPOSITORY";
  /* Template custom: data-contract-jsdoc */
  tag:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
}

/* Template custom: data-contract-jsdoc */
export interface ApiInvitationResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  scope: "VFO" | "INTERWILL" | "REPOSITORY";
  /* Template custom: data-contract-jsdoc */
  tag:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
  /* Template custom: data-contract-jsdoc */
  expiresAt: string;
  /* Template custom: data-contract-jsdoc */
  acceptedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  invitationToken?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateInvitationDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  firstName?: string;
  /* Template custom: data-contract-jsdoc */
  lastName?: string;
  /* Template custom: data-contract-jsdoc */
  tag:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
}

/* Template custom: data-contract-jsdoc */
export interface ApiAcceptInvitationDto {
  /* Template custom: data-contract-jsdoc */
  token: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPinOprfEvaluateDto {
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
  /* Template custom: data-contract-jsdoc */
  blindedRequest: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPinOprfEvaluationResponse {
  /* Template custom: data-contract-jsdoc */
  suite: string;
  /* Template custom: data-contract-jsdoc */
  evaluation: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPinSetupDto {
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
  /* Template custom: data-contract-jsdoc */
  verifier: string;
  /* Template custom: data-contract-jsdoc */
  encryptedPayload: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPinUnlockDto {
  /* Template custom: data-contract-jsdoc */
  refreshToken?: string;
  /* Template custom: data-contract-jsdoc */
  verifier: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPinUnlockResponse {
  /* Template custom: data-contract-jsdoc */
  encryptedPayload: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiErrorDetailResponse {
  /* Template custom: data-contract-jsdoc */
  field: string;
  /* Template custom: data-contract-jsdoc */
  message: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiErrorResponse {
  /* Template custom: data-contract-jsdoc */
  errorCode: string;
  /* Template custom: data-contract-jsdoc */
  message: string;
  /* Template custom: data-contract-jsdoc */
  details: ApiErrorDetailResponse[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentMetadataDto {
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentCertificateResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  signingCertificate: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  version: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyDocumentCertificateDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  signingCertificate: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  version: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentCertificateVerifyResponse {
  /* Template custom: data-contract-jsdoc */
  isValid: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVideoMetadataDto {
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  durationSeconds: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  resolution: string;
  /* Template custom: data-contract-jsdoc */
  frameRate?: string;
  /* Template custom: data-contract-jsdoc */
  videoCodec?: string;
  /* Template custom: data-contract-jsdoc */
  hasAudio: boolean;
  /* Template custom: data-contract-jsdoc */
  audioCodec?: string;
  /* Template custom: data-contract-jsdoc */
  recordingStartedAt?: string;
  /* Template custom: data-contract-jsdoc */
  recordingEndedAt?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVideoCertificateResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  durationSeconds: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  resolution: string;
  /* Template custom: data-contract-jsdoc */
  frameRate?: string | null;
  /* Template custom: data-contract-jsdoc */
  videoCodec?: string | null;
  /* Template custom: data-contract-jsdoc */
  hasAudio: boolean;
  /* Template custom: data-contract-jsdoc */
  audioCodec?: string | null;
  /* Template custom: data-contract-jsdoc */
  recordingStartedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  recordingEndedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  signingCertificate: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  version: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVerifyVideoCertificateDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  willId: string;
  /* Template custom: data-contract-jsdoc */
  attachmentId: string;
  /* Template custom: data-contract-jsdoc */
  hash: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  durationSeconds: number;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  resolution: string;
  /* Template custom: data-contract-jsdoc */
  hasAudio: boolean;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  signingCertificate: string;
  /* Template custom: data-contract-jsdoc */
  frameRate?: string | null;
  /* Template custom: data-contract-jsdoc */
  videoCodec?: string | null;
  /* Template custom: data-contract-jsdoc */
  audioCodec?: string | null;
  /* Template custom: data-contract-jsdoc */
  recordingStartedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  recordingEndedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  version: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiVideoCertificateVerifyResponse {
  /* Template custom: data-contract-jsdoc */
  isValid: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCollectionSummaryResponse {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiItemResponse {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  encryptedData: string;
  /* Template custom: data-contract-jsdoc */
  encryptedSymmetricKeys: string;
  /* Template custom: data-contract-jsdoc */
  permissions: string;
  /* Template custom: data-contract-jsdoc */
  signature: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCollectionResponse {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  items: ApiItemResponse[];
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGetItemByDtoIdDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPermissionDto {
  /* Template custom: data-contract-jsdoc */
  __dataType: string;
  /* Template custom: data-contract-jsdoc */
  value: ApiPermissionMapEntryDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateItemDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  encryptedData: string;
  /* Template custom: data-contract-jsdoc */
  encryptedSymmetricKeys: ApiEncryptedSymmetricKeysDto;
  /* Template custom: data-contract-jsdoc */
  permissions: ApiPermissionDto;
  /* Template custom: data-contract-jsdoc */
  signature?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDeleteItemDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  signature?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPermissionMapEntryDto {
  /* Template custom: data-contract-jsdoc */
  key: string;
  /* Template custom: data-contract-jsdoc */
  value: ApiPermissionSetDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateItemDto {
  /* Template custom: data-contract-jsdoc */
  dtoId: string;
  /* Template custom: data-contract-jsdoc */
  encryptedData: string;
  /* Template custom: data-contract-jsdoc */
  encryptedSymmetricKeys: ApiEncryptedSymmetricKeysDto;
  /* Template custom: data-contract-jsdoc */
  permissions: ApiPermissionDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchCreateDto {
  /* Template custom: data-contract-jsdoc */
  items: ApiCreateItemDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchUpdateDto {
  /* Template custom: data-contract-jsdoc */
  items: ApiUpdateItemDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchDeleteDto {
  /* Template custom: data-contract-jsdoc */
  items: ApiDeleteItemDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  deletedAt: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCurrencyRateResponse {
  /* Template custom: data-contract-jsdoc */
  baseCurrency: string;
  /* Template custom: data-contract-jsdoc */
  quoteCurrency: string;
  /* Template custom: data-contract-jsdoc */
  rate: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRegionResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  code: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  deletedAt: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetFieldResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  weight: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetCategoryResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  assetFields: ApiAssetFieldResponse[];
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDatetimeTriggerResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  scheduledAt: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiInactivityTriggerResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  afterDays: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCheckMeTriggerResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  afterDays: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTriggersResponse {
  /* Template custom: data-contract-jsdoc */
  datetime?: ApiDatetimeTriggerResponse | null;
  /* Template custom: data-contract-jsdoc */
  inactivity?: ApiInactivityTriggerResponse | null;
  /* Template custom: data-contract-jsdoc */
  checkMe?: ApiCheckMeTriggerResponse | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiNotificationSettingsResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  daysBeforeTrigger: number;
  /* Template custom: data-contract-jsdoc */
  daysBetweenNotifications: number;
  /* Template custom: data-contract-jsdoc */
  notificationTime: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiNotificationResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  scheduledAt: string;
  /* Template custom: data-contract-jsdoc */
  sentAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTransferResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  recipientProfileId: number;
  /* Template custom: data-contract-jsdoc */
  isTest: boolean;
  /* Template custom: data-contract-jsdoc */
  acceptedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  transferredAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  revokedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  delayDays: number;
  /* Template custom: data-contract-jsdoc */
  expirationDays?: number | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiScenarioResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  status: "DRAFT" | "ACTIVE" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  triggerCondition: "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  transferCondition: "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  triggers?: ApiTriggersResponse | null;
  /* Template custom: data-contract-jsdoc */
  notificationSettings?: ApiNotificationSettingsResponse | null;
  /* Template custom: data-contract-jsdoc */
  notifications: ApiNotificationResponse[];
  /* Template custom: data-contract-jsdoc */
  transfers: ApiTransferResponse[];
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  testDtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  permissions: number[];
  /* Template custom: data-contract-jsdoc */
  completedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  cancelledAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDatetimeTriggerDto {
  /* Template custom: data-contract-jsdoc */
  scheduledAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiInactivityTriggerDto {
  /* Template custom: data-contract-jsdoc */
  afterDays: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCheckMeTriggerDto {
  /* Template custom: data-contract-jsdoc */
  afterDays: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTriggersDto {
  /* Template custom: data-contract-jsdoc */
  datetime?: ApiDatetimeTriggerDto;
  /* Template custom: data-contract-jsdoc */
  inactivity?: ApiInactivityTriggerDto;
  /* Template custom: data-contract-jsdoc */
  checkMe?: ApiCheckMeTriggerDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiNotificationSettingsDto {
  /* Template custom: data-contract-jsdoc */
  daysBeforeTrigger: number;
  /* Template custom: data-contract-jsdoc */
  daysBetweenNotifications: number;
  /* Template custom: data-contract-jsdoc */
  notificationTime: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiNotificationDto {
  /* Template custom: data-contract-jsdoc */
  scheduledAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTransferDto {
  /* Template custom: data-contract-jsdoc */
  recipientProfileId: number;
  /* Template custom: data-contract-jsdoc */
  isTest?: boolean;
  /* Template custom: data-contract-jsdoc */
  delayDays?: number;
  /* Template custom: data-contract-jsdoc */
  expirationDays?: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateScenarioDto {
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  testDtoIds?: string[];
  /* Template custom: data-contract-jsdoc */
  triggers?: ApiTriggersDto;
  /* Template custom: data-contract-jsdoc */
  triggerCondition?: "1" | "2" | "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  transferCondition?: "1" | "2" | "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  notificationSettings?: ApiNotificationSettingsDto;
  /* Template custom: data-contract-jsdoc */
  notifications?: ApiNotificationDto[];
  /* Template custom: data-contract-jsdoc */
  transfers?: ApiTransferDto[];
  /* Template custom: data-contract-jsdoc */
  permissions?: number[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateCollectionItemIdDto {
  /* Template custom: data-contract-jsdoc */
  collectionItemId?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSharedScenarioResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  status: "DRAFT" | "ACTIVE" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  triggerCondition: "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  transferCondition: "ONE_OF" | "ALL_OF";
  /* Template custom: data-contract-jsdoc */
  triggers?: ApiTriggersResponse | null;
  /* Template custom: data-contract-jsdoc */
  notificationSettings?: ApiNotificationSettingsResponse | null;
  /* Template custom: data-contract-jsdoc */
  notifications: ApiNotificationResponse[];
  /* Template custom: data-contract-jsdoc */
  transfers: ApiTransferResponse[];
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  testDtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  completedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  cancelledAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiIncomingTransferResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  scenarioId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  dtoIds: string[];
  /* Template custom: data-contract-jsdoc */
  recipientProfileId: number;
  /* Template custom: data-contract-jsdoc */
  isTest: boolean;
  /* Template custom: data-contract-jsdoc */
  acceptedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  transferredAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  revokedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  delayDays: number;
  /* Template custom: data-contract-jsdoc */
  expirationDays?: number | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateSubscriptionDto {
  /* Template custom: data-contract-jsdoc */
  id?: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  platformId: number;
  /* Template custom: data-contract-jsdoc */
  statusId: number;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew: boolean;
  /* Template custom: data-contract-jsdoc */
  profileId?: number;
  /* Template custom: data-contract-jsdoc */
  planId: number;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionStatusDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  code: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionPlanDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  name: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionPlatformDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  code: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateSubscriptionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  planId: number;
  /* Template custom: data-contract-jsdoc */
  statusId: number;
  /* Template custom: data-contract-jsdoc */
  platformId: number;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
  /* Template custom: data-contract-jsdoc */
  shouldCancel: boolean;
  /* Template custom: data-contract-jsdoc */
  cacheInvalidated: boolean;
  /* Template custom: data-contract-jsdoc */
  alreadyHadActiveSubscription?: boolean;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew: boolean;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  canceledAt?: string;
  /* Template custom: data-contract-jsdoc */
  status: ApiSubscriptionStatusDto;
  /* Template custom: data-contract-jsdoc */
  plan: ApiSubscriptionPlanDto;
  /* Template custom: data-contract-jsdoc */
  platform: ApiSubscriptionPlatformDto;
  /* Template custom: data-contract-jsdoc */
  nextPhase?: object | null;
  /* Template custom: data-contract-jsdoc */
  refundAvailable?: boolean;
  /* Template custom: data-contract-jsdoc */
  hadCancelledSubscriptions?: boolean;
  /* Template custom: data-contract-jsdoc */
  cancelAtPeriodEnd?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateSubscriptionDto {
  /* Template custom: data-contract-jsdoc */
  id?: string;
  /* Template custom: data-contract-jsdoc */
  email?: string;
  /* Template custom: data-contract-jsdoc */
  platformId?: number;
  /* Template custom: data-contract-jsdoc */
  statusId?: number;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt?: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt?: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew?: boolean;
  /* Template custom: data-contract-jsdoc */
  userId?: number;
  /* Template custom: data-contract-jsdoc */
  planId?: number;
  /* Template custom: data-contract-jsdoc */
  externalUserId?: string;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateSubscriptionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  planId: number;
  /* Template custom: data-contract-jsdoc */
  statusId: number;
  /* Template custom: data-contract-jsdoc */
  platformId: number;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
  /* Template custom: data-contract-jsdoc */
  shouldCancel: boolean;
  /* Template custom: data-contract-jsdoc */
  cacheInvalidated: boolean;
  /* Template custom: data-contract-jsdoc */
  alreadyHadActiveSubscription?: boolean;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew: boolean;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  canceledAt?: string;
  /* Template custom: data-contract-jsdoc */
  status: ApiSubscriptionStatusDto;
  /* Template custom: data-contract-jsdoc */
  plan: ApiSubscriptionPlanDto;
  /* Template custom: data-contract-jsdoc */
  platform: ApiSubscriptionPlatformDto;
  /* Template custom: data-contract-jsdoc */
  nextPhase?: object | null;
  /* Template custom: data-contract-jsdoc */
  refundAvailable?: boolean;
  /* Template custom: data-contract-jsdoc */
  hadCancelledSubscriptions?: boolean;
  /* Template custom: data-contract-jsdoc */
  cancelAtPeriodEnd?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCancelSubscriptionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  planId: number;
  /* Template custom: data-contract-jsdoc */
  statusId: number;
  /* Template custom: data-contract-jsdoc */
  platformId: number;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
  /* Template custom: data-contract-jsdoc */
  shouldCancel: boolean;
  /* Template custom: data-contract-jsdoc */
  cacheInvalidated: boolean;
  /* Template custom: data-contract-jsdoc */
  alreadyHadActiveSubscription?: boolean;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew: boolean;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  canceledAt?: string;
  /* Template custom: data-contract-jsdoc */
  status: ApiSubscriptionStatusDto;
  /* Template custom: data-contract-jsdoc */
  plan: ApiSubscriptionPlanDto;
  /* Template custom: data-contract-jsdoc */
  platform: ApiSubscriptionPlatformDto;
  /* Template custom: data-contract-jsdoc */
  nextPhase?: object | null;
  /* Template custom: data-contract-jsdoc */
  refundAvailable?: boolean;
  /* Template custom: data-contract-jsdoc */
  hadCancelledSubscriptions?: boolean;
  /* Template custom: data-contract-jsdoc */
  cancelAtPeriodEnd?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGetSubscriptionStatusResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  planId: number;
  /* Template custom: data-contract-jsdoc */
  statusId: number;
  /* Template custom: data-contract-jsdoc */
  platformId: number;
  /* Template custom: data-contract-jsdoc */
  externalCustomerId?: string;
  /* Template custom: data-contract-jsdoc */
  shouldCancel: boolean;
  /* Template custom: data-contract-jsdoc */
  cacheInvalidated: boolean;
  /* Template custom: data-contract-jsdoc */
  alreadyHadActiveSubscription?: boolean;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStartedAt: string;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEndedAt: string;
  /* Template custom: data-contract-jsdoc */
  autoRenew: boolean;
  /* Template custom: data-contract-jsdoc */
  originalTransactionId?: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  canceledAt?: string;
  /* Template custom: data-contract-jsdoc */
  status: ApiSubscriptionStatusDto;
  /* Template custom: data-contract-jsdoc */
  plan: ApiSubscriptionPlanDto;
  /* Template custom: data-contract-jsdoc */
  platform: ApiSubscriptionPlatformDto;
  /* Template custom: data-contract-jsdoc */
  nextPhase?: object | null;
  /* Template custom: data-contract-jsdoc */
  refundAvailable?: boolean;
  /* Template custom: data-contract-jsdoc */
  hadCancelledSubscriptions?: boolean;
  /* Template custom: data-contract-jsdoc */
  cancelAtPeriodEnd?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAppStoreServerNotificationDto {
  /* Template custom: data-contract-jsdoc */
  signedPayload: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateCustomerDto {
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  name?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCustomerResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  name?: string;
  /* Template custom: data-contract-jsdoc */
  created: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCustomerExistsResponse {
  /* Template custom: data-contract-jsdoc */
  exists: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPriceDataDto {
  /* Template custom: data-contract-jsdoc */
  currency: string;
  /* Template custom: data-contract-jsdoc */
  unitAmount: number;
  /* Template custom: data-contract-jsdoc */
  productName: string;
  /* Template custom: data-contract-jsdoc */
  quantity?: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateCheckoutSessionDto {
  /* Template custom: data-contract-jsdoc */
  customerId: string;
  /* Template custom: data-contract-jsdoc */
  priceId?: string;
  /* Template custom: data-contract-jsdoc */
  priceData?: ApiPriceDataDto;
  /* Template custom: data-contract-jsdoc */
  successUrl: string;
  /* Template custom: data-contract-jsdoc */
  cancelUrl: string;
  /* Template custom: data-contract-jsdoc */
  mode: "payment" | "subscription";
  /* Template custom: data-contract-jsdoc */
  clientReferenceId?: string;
  /* Template custom: data-contract-jsdoc */
  profileId?: number;
  /* Template custom: data-contract-jsdoc */
  userId?: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCheckoutSessionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  url: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateSubscriptionIntentDto {
  /* Template custom: data-contract-jsdoc */
  customerId: string;
  /* Template custom: data-contract-jsdoc */
  priceId: string;
  /* Template custom: data-contract-jsdoc */
  trialEnd?: number;
  /* Template custom: data-contract-jsdoc */
  profileId?: number;
  /* Template custom: data-contract-jsdoc */
  userId?: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionIntentResponse {
  /* Template custom: data-contract-jsdoc */
  subscriptionId: string;
  /* Template custom: data-contract-jsdoc */
  clientSecret: string;
  /* Template custom: data-contract-jsdoc */
  price: number;
  /* Template custom: data-contract-jsdoc */
  tax: number;
  /* Template custom: data-contract-jsdoc */
  date: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiStripeCancelSubscriptionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  cancel_at_period_end: boolean;
  /* Template custom: data-contract-jsdoc */
  cancel_at?: number;
  /* Template custom: data-contract-jsdoc */
  canceled_at?: number;
  /* Template custom: data-contract-jsdoc */
  current_period_end?: number;
  /* Template custom: data-contract-jsdoc */
  items: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBooleanResponse {
  /* Template custom: data-contract-jsdoc */
  result: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubscriptionDetailsResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  customerId: string;
  /* Template custom: data-contract-jsdoc */
  priceId: string;
  /* Template custom: data-contract-jsdoc */
  planInterval: "day" | "week" | "month" | "year";
  /* Template custom: data-contract-jsdoc */
  planIntervalCount: number;
  /* Template custom: data-contract-jsdoc */
  currentPeriodStart: number;
  /* Template custom: data-contract-jsdoc */
  currentPeriodEnd: number;
  /* Template custom: data-contract-jsdoc */
  cancelAtPeriodEnd: boolean;
  /* Template custom: data-contract-jsdoc */
  canceledAt?: number;
  /* Template custom: data-contract-jsdoc */
  schedule?: object;
  /* Template custom: data-contract-jsdoc */
  refundAvailable?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRefundAvailabilityResponse {
  /* Template custom: data-contract-jsdoc */
  available: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUnpaidInvoiceResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  date: number;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  status?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUnpaidInvoicesResponse {
  /* Template custom: data-contract-jsdoc */
  invoices: ApiUnpaidInvoiceResponse[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentMethodCardResponse {
  /* Template custom: data-contract-jsdoc */
  brand?: string;
  /* Template custom: data-contract-jsdoc */
  last4?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentMethodResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  card?: ApiPaymentMethodCardResponse;
  /* Template custom: data-contract-jsdoc */
  isBackup: boolean;
  /* Template custom: data-contract-jsdoc */
  isFailed: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentMethodsListResponse {
  /* Template custom: data-contract-jsdoc */
  methods: ApiPaymentMethodResponse[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiSetupIntentDto {
  /* Template custom: data-contract-jsdoc */
  customerId: string;
  /* Template custom: data-contract-jsdoc */
  metadata?: object;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSetupIntentResponse {
  /* Template custom: data-contract-jsdoc */
  clientSecret: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentHistoryItemResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  created: number;
  /* Template custom: data-contract-jsdoc */
  last4?: string;
  /* Template custom: data-contract-jsdoc */
  priceId?: string;
  /* Template custom: data-contract-jsdoc */
  status: "paid" | "failed" | "refund_pending" | "refunded";
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentHistoryResponse {
  /* Template custom: data-contract-jsdoc */
  payments: ApiPaymentHistoryItemResponse[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiInvoiceRefundStatusResponse {
  /* Template custom: data-contract-jsdoc */
  refunded: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBillingPortalDto {
  /* Template custom: data-contract-jsdoc */
  customerId: string;
  /* Template custom: data-contract-jsdoc */
  returnUrl?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBillingPortalResponse {
  /* Template custom: data-contract-jsdoc */
  url: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiParticipantResponse {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  chatId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  status: "ONLINE" | "OFFLINE";
  /* Template custom: data-contract-jsdoc */
  lastSeenAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAttachmentDeletedResponse {
  /* Template custom: data-contract-jsdoc */
  deleted: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAttachmentExistingResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  messageId: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  title?: string | null;
  /* Template custom: data-contract-jsdoc */
  mimeType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMessageReadMarkResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  messageId: string;
  /* Template custom: data-contract-jsdoc */
  readAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMessageResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  chatId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  messageType: "TEXT" | "AUDIO";
  /* Template custom: data-contract-jsdoc */
  body?: string | null;
  /* Template custom: data-contract-jsdoc */
  replyToMessageId?: string | null;
  /* Template custom: data-contract-jsdoc */
  isSystem: boolean;
  /* Template custom: data-contract-jsdoc */
  editedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  attachments: ApiAttachmentDeletedResponse[] | ApiAttachmentExistingResponse[];
  /* Template custom: data-contract-jsdoc */
  messageReadMarks: ApiMessageReadMarkResponse[];
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiChatResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  chatType: string;
  /* Template custom: data-contract-jsdoc */
  title?: string | null;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  isReadonly: boolean;
  /* Template custom: data-contract-jsdoc */
  participants: ApiParticipantResponse[];
  /* Template custom: data-contract-jsdoc */
  messages: ApiMessageResponse[];
  /* Template custom: data-contract-jsdoc */
  lastMessage?: ApiMessageResponse | null;
  /* Template custom: data-contract-jsdoc */
  unreadCount: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateChatDto {
  /* Template custom: data-contract-jsdoc */
  chatType: "DIRECT" | "SELF" | "CASE";
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  participantProfileIds?: number[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateChatDto {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddParticipantDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateAttachmentDto {
  /* Template custom: data-contract-jsdoc */
  title?: string | null;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  mimeType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateMessageDto {
  /* Template custom: data-contract-jsdoc */
  chatId: string;
  /* Template custom: data-contract-jsdoc */
  messageType: "TEXT" | "AUDIO";
  /* Template custom: data-contract-jsdoc */
  body?: string;
  /* Template custom: data-contract-jsdoc */
  replyToMessageId?: string;
  /* Template custom: data-contract-jsdoc */
  attachments?: ApiCreateAttachmentDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiReadMessageBatchDto {
  /* Template custom: data-contract-jsdoc */
  messageIds: string[];
  /* Template custom: data-contract-jsdoc */
  chatId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateMessageDto {
  /* Template custom: data-contract-jsdoc */
  body: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseMemberResponseV2 {
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  tagCode?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  status: "AWAIT_AUTHORISATION" | "REGISTERED";
  /* Template custom: data-contract-jsdoc */
  accessLevel: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskDocumentResponseV2 {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: string;
  /* Template custom: data-contract-jsdoc */
  source: "UPLOAD" | "CHAT" | "EXTERNAL";
  /* Template custom: data-contract-jsdoc */
  dtoId?: string | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskResponseV2 {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  taskNumber: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  status: "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  priority: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  assignee?: ApiCaseMemberResponseV2 | null;
  /* Template custom: data-contract-jsdoc */
  creator: ApiCaseMemberResponseV2;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdFromMessageId?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastStatusChangedAt: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  completedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  deletedAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  age: string;
  /* Template custom: data-contract-jsdoc */
  documents: ApiTaskDocumentResponseV2[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseDocumentResponseV2 {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  documentId: string;
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiActivityChangesDto {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  background?: string;
  /* Template custom: data-contract-jsdoc */
  chatId?: string;
  /* Template custom: data-contract-jsdoc */
  status?: string;
  /* Template custom: data-contract-jsdoc */
  priority?: string;
  /* Template custom: data-contract-jsdoc */
  assigneeCaseMemberId?: string;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string;
  /* Template custom: data-contract-jsdoc */
  tag?: string;
  /* Template custom: data-contract-jsdoc */
  country?: string;
  /* Template custom: data-contract-jsdoc */
  fileName?: string;
  /* Template custom: data-contract-jsdoc */
  fileType?: string;
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiActivityUpdatedFieldsDto {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  background?:
    | "GENERAL"
    | "HOUSE"
    | "KEY"
    | "INVOICE"
    | "CERTIFICATE"
    | "USERS"
    | "BUILDINGS"
    | "BANK"
    | "BRIEFCASE"
    | "GLOBE"
    | "ARCHIVE";
  /* Template custom: data-contract-jsdoc */
  chatId?: string;
  /* Template custom: data-contract-jsdoc */
  status?: "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  priority?: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  /* Template custom: data-contract-jsdoc */
  assigneeCaseMemberId?: string;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string;
  /* Template custom: data-contract-jsdoc */
  createdFromMessageId?: string;
  /* Template custom: data-contract-jsdoc */
  tag?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
  /* Template custom: data-contract-jsdoc */
  country?: string;
  /* Template custom: data-contract-jsdoc */
  fileName?: string;
  /* Template custom: data-contract-jsdoc */
  fileType?: string;
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes?: number;
  /* Template custom: data-contract-jsdoc */
  source?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiActivityMetadataDto {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  changes?: ApiActivityChangesDto;
  /* Template custom: data-contract-jsdoc */
  updatedFields?: ApiActivityUpdatedFieldsDto;
  /* Template custom: data-contract-jsdoc */
  priority?: string;
  /* Template custom: data-contract-jsdoc */
  status?: string;
  /* Template custom: data-contract-jsdoc */
  assigneeProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  previousStatus?: string;
  /* Template custom: data-contract-jsdoc */
  newStatus?: string;
  /* Template custom: data-contract-jsdoc */
  fileName?: string;
  /* Template custom: data-contract-jsdoc */
  fileType?: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes?: string;
  /* Template custom: data-contract-jsdoc */
  filePath?: string;
  /* Template custom: data-contract-jsdoc */
  isGeneralCase?: boolean;
  /* Template custom: data-contract-jsdoc */
  isPrivateCase?: boolean;
  /* Template custom: data-contract-jsdoc */
  inviterProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  memberProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  privateCaseId?: string;
  /* Template custom: data-contract-jsdoc */
  generalCaseId?: string;
  /* Template custom: data-contract-jsdoc */
  addedByProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  removedProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  caseTitle?: string;
  /* Template custom: data-contract-jsdoc */
  tagId?: number;
  /* Template custom: data-contract-jsdoc */
  tenantProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  profileId?: number;
  /* Template custom: data-contract-jsdoc */
  tag?: string;
  /* Template custom: data-contract-jsdoc */
  usedExistingTag?: boolean;
  /* Template custom: data-contract-jsdoc */
  finalTagId?: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiActivityLogResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  profileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  caseMemberId?: string | null;
  /* Template custom: data-contract-jsdoc */
  actionType: string;
  /* Template custom: data-contract-jsdoc */
  entityType: string;
  /* Template custom: data-contract-jsdoc */
  entityId: string;
  /* Template custom: data-contract-jsdoc */
  caseId?: string | null;
  /* Template custom: data-contract-jsdoc */
  metadata?: ApiActivityMetadataDto | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseResponseV2 {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  isGeneralCase: boolean;
  /* Template custom: data-contract-jsdoc */
  isPrivateCase: boolean;
  /* Template custom: data-contract-jsdoc */
  background:
    | "GENERAL"
    | "HOUSE"
    | "KEY"
    | "INVOICE"
    | "CERTIFICATE"
    | "USERS"
    | "BUILDINGS"
    | "BANK"
    | "BRIEFCASE"
    | "GLOBE"
    | "ARCHIVE";
  /* Template custom: data-contract-jsdoc */
  chatId?: string | null;
  /* Template custom: data-contract-jsdoc */
  members: ApiCaseMemberResponseV2[];
  /* Template custom: data-contract-jsdoc */
  tasks: ApiTaskResponseV2[];
  /* Template custom: data-contract-jsdoc */
  caseDocuments: ApiCaseDocumentResponseV2[];
  /* Template custom: data-contract-jsdoc */
  activityLogs: ApiActivityLogResponse[];
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  deletedAt?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateCaseDto {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  isGeneralCase?: boolean;
  /* Template custom: data-contract-jsdoc */
  background?:
    | "GENERAL"
    | "HOUSE"
    | "KEY"
    | "INVOICE"
    | "CERTIFICATE"
    | "USERS"
    | "BUILDINGS"
    | "BANK"
    | "BRIEFCASE"
    | "GLOBE"
    | "ARCHIVE";
  /* Template custom: data-contract-jsdoc */
  chatId?: string;
  /* Template custom: data-contract-jsdoc */
  memberProfileIds?: number[];
}

/* Template custom: data-contract-jsdoc */
export type ApiUpdateCaseDto = object;

/* Template custom: data-contract-jsdoc */
export interface ApiAddCaseMemberDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  tag:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
  /* Template custom: data-contract-jsdoc */
  country?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveCaseMemberDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSyncCaseMemberCasesDto {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  caseIds: string[];
  /* Template custom: data-contract-jsdoc */
  assigneeTasksPolicy?: "UNASSIGN" | "DELETE";
  /* Template custom: data-contract-jsdoc */
  creatorTasksPolicy?: "KEEP" | "DELETE";
  /* Template custom: data-contract-jsdoc */
  documentsPolicy?:
    | "KEEP_IN_CASE"
    | "REMOVE_FROM_CASE"
    | "COPY_TO_PRIVATE_CASE";
}

/* Template custom: data-contract-jsdoc */
export interface ApiSyncCaseMembersDto {
  /* Template custom: data-contract-jsdoc */
  profileIds: number[];
  /* Template custom: data-contract-jsdoc */
  assigneeTasksPolicy?: "UNASSIGN" | "DELETE";
  /* Template custom: data-contract-jsdoc */
  creatorTasksPolicy?: "KEEP" | "DELETE";
  /* Template custom: data-contract-jsdoc */
  documentsPolicy?:
    | "KEEP_IN_CASE"
    | "REMOVE_FROM_CASE"
    | "COPY_TO_PRIVATE_CASE";
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateTaskDtoV2 {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  status: "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  priority: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  assigneeProfileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdFromMessageId?: string;
  /* Template custom: data-contract-jsdoc */
  documentIds?: string[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateTaskDtoV2 {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  description?: string;
  /* Template custom: data-contract-jsdoc */
  status?: "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED";
  /* Template custom: data-contract-jsdoc */
  priority?: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  /* Template custom: data-contract-jsdoc */
  assigneeProfileId?: number | null;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  caseId?: string;
  /* Template custom: data-contract-jsdoc */
  shouldMoveDocs?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddTaskDocumentsDtoV2 {
  /* Template custom: data-contract-jsdoc */
  documentIds: string[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateActivityLogDto {
  /* Template custom: data-contract-jsdoc */
  profileId?: number;
  /* Template custom: data-contract-jsdoc */
  caseMemberId?: string;
  /* Template custom: data-contract-jsdoc */
  actionType:
    | "CREATE"
    | "UPDATE"
    | "DELETE"
    | "ADD_MEMBER"
    | "REMOVE_MEMBER"
    | "UPLOAD"
    | "COMPLETE"
    | "CANCEL"
    | "VFO_MEMBER_CREATED"
    | "VFO_MEMBER_REMOVED";
  /* Template custom: data-contract-jsdoc */
  entityType: "CASE" | "CASE_MEMBER" | "DOCUMENT" | "TASK";
  /* Template custom: data-contract-jsdoc */
  entityId: string;
  /* Template custom: data-contract-jsdoc */
  caseId?: string;
  /* Template custom: data-contract-jsdoc */
  metadata?: ApiActivityMetadataDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentResponseV2 {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  filePath: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: string;
  /* Template custom: data-contract-jsdoc */
  source: "UPLOAD" | "CHAT" | "EXTERNAL";
  /* Template custom: data-contract-jsdoc */
  caseMember: ApiCaseMemberResponseV2;
  /* Template custom: data-contract-jsdoc */
  dtoId?: string | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  caseDocuments: ApiCaseDocumentResponseV2[];
  /* Template custom: data-contract-jsdoc */
  documentReads: {
    /* Template custom: data-contract-jsdoc */
    profileId?: number;
    /* Template custom: data-contract-jsdoc */
    createdAt?: string;
  }[];
  /* Template custom: data-contract-jsdoc */
  isNew: boolean;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
  /* Template custom: data-contract-jsdoc */
  deletedAt?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateDocumentDtoV2 {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  fileContent: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  source: "UPLOAD" | "CHAT" | "EXTERNAL";
  /* Template custom: data-contract-jsdoc */
  caseIds?: string[];
  /* Template custom: data-contract-jsdoc */
  caseId?: string;
  /* Template custom: data-contract-jsdoc */
  uploaderProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  dtoId?: string;
  /* Template custom: data-contract-jsdoc */
  country?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateDocumentMultipartBodyDtoV2 {
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  source: "UPLOAD" | "CHAT" | "EXTERNAL";
  /* Template custom: data-contract-jsdoc */
  caseIds?: string[];
  /* Template custom: data-contract-jsdoc */
  caseId?: string;
  /* Template custom: data-contract-jsdoc */
  uploaderProfileId?: number;
  /* Template custom: data-contract-jsdoc */
  dtoId?: string;
  /* Template custom: data-contract-jsdoc */
  country?: string;
  /* Template custom: data-contract-jsdoc */
  file: File;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateDocumentDtoV2 {
  /* Template custom: data-contract-jsdoc */
  title?: string;
  /* Template custom: data-contract-jsdoc */
  fileContent?: string;
  /* Template custom: data-contract-jsdoc */
  fileName?: string;
  /* Template custom: data-contract-jsdoc */
  fileType?: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes?: number;
  /* Template custom: data-contract-jsdoc */
  source?: "UPLOAD" | "CHAT" | "EXTERNAL";
  /* Template custom: data-contract-jsdoc */
  dtoId?: string;
  /* Template custom: data-contract-jsdoc */
  country?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddDocumentToCaseDto {
  /* Template custom: data-contract-jsdoc */
  caseId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDownloadDocumentDto {
  /* Template custom: data-contract-jsdoc */
  filePath: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentDownloadResponse {
  /* Template custom: data-contract-jsdoc */
  fileContent: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRemoveDocumentFromCaseDto {
  /* Template custom: data-contract-jsdoc */
  caseId: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiKpiData {
  /* Template custom: data-contract-jsdoc */
  totalTasks: number;
  /* Template custom: data-contract-jsdoc */
  overdueTasks: number;
  /* Template custom: data-contract-jsdoc */
  tasksWithoutAssignee: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTasksHealthData {
  /* Template custom: data-contract-jsdoc */
  activeTasks: number;
  /* Template custom: data-contract-jsdoc */
  doneTasks: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRecentActivityData {
  /* Template custom: data-contract-jsdoc */
  newTasks: number;
  /* Template custom: data-contract-jsdoc */
  newDocuments: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskActivitySummary {
  /* Template custom: data-contract-jsdoc */
  created: number;
  /* Template custom: data-contract-jsdoc */
  dueSoon: number;
  /* Template custom: data-contract-jsdoc */
  updated: number;
  /* Template custom: data-contract-jsdoc */
  completed: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskStatusOverview {
  /* Template custom: data-contract-jsdoc */
  toDo: number;
  /* Template custom: data-contract-jsdoc */
  inProgress: number;
  /* Template custom: data-contract-jsdoc */
  done: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPriorityBreakdown {
  /* Template custom: data-contract-jsdoc */
  high: number;
  /* Template custom: data-contract-jsdoc */
  medium: number;
  /* Template custom: data-contract-jsdoc */
  low: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiChartsData {
  /* Template custom: data-contract-jsdoc */
  tasksHealth: ApiTasksHealthData;
  /* Template custom: data-contract-jsdoc */
  recentActivity: ApiRecentActivityData;
  /* Template custom: data-contract-jsdoc */
  taskActivity: ApiTaskActivitySummary;
  /* Template custom: data-contract-jsdoc */
  taskStatusOverview: ApiTaskStatusOverview;
  /* Template custom: data-contract-jsdoc */
  priorityBreakdown: ApiPriorityBreakdown;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAnalyticsResponse {
  /* Template custom: data-contract-jsdoc */
  kpi: ApiKpiData;
  /* Template custom: data-contract-jsdoc */
  charts: ApiChartsData;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCreateCaseMemberInternalDto {
  /* Template custom: data-contract-jsdoc */
  tenantProfileId: number;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  tag:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
  /* Template custom: data-contract-jsdoc */
  country?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseMemberResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  tagCode?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  addedByCaseMemberId?: string | null;
  /* Template custom: data-contract-jsdoc */
  status: "AWAIT_AUTHORISATION" | "REGISTERED";
  /* Template custom: data-contract-jsdoc */
  accessLevel: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseMemberEnrichedResponseV2 {
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  tagCode?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  registrationDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  status: "AWAIT_AUTHORISATION" | "REGISTERED";
  /* Template custom: data-contract-jsdoc */
  accessLevel: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
  /* Template custom: data-contract-jsdoc */
  updatedAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseMemberGroupedResponseV2 {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  tagCode?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  accessLevel: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  status: "AWAIT_AUTHORISATION" | "REGISTERED";
  /* Template custom: data-contract-jsdoc */
  cases: string[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateCaseMemberDtoV2 {
  /* Template custom: data-contract-jsdoc */
  tag?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE";
  /* Template custom: data-contract-jsdoc */
  country?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateCaseMemberSelfDtoV2 {
  /* Template custom: data-contract-jsdoc */
  country?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPermissionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  code:
    | "people.view_all"
    | "people.view_selected"
    | "cases.create"
    | "cases.view_all"
    | "cases.manage"
    | "documents.manage_limited"
    | "documents.manage"
    | "members.manage_lifecycle"
    | "settings.manage"
    | "analytics.view";
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  category: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRoleResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  code: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  isSystem: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUserRoleResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  roleCode: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  grantedAt: string;
  /* Template custom: data-contract-jsdoc */
  expiresAt?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGrantRoleDto {
  /* Template custom: data-contract-jsdoc */
  roleCode: "BASIC" | "CONNECTED" | "DELEGATED" | "EXECUTIVE";
  /* Template custom: data-contract-jsdoc */
  expiresAt?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiGrantPermissionDto {
  /* Template custom: data-contract-jsdoc */
  permissionCode:
    | "people.view_all"
    | "people.view_selected"
    | "cases.create"
    | "cases.view_all"
    | "cases.manage"
    | "documents.manage_limited"
    | "documents.manage"
    | "members.manage_lifecycle"
    | "settings.manage"
    | "analytics.view";
  /* Template custom: data-contract-jsdoc */
  isGranted?: boolean;
  /* Template custom: data-contract-jsdoc */
  expiresAt?: string;
  /* Template custom: data-contract-jsdoc */
  reason?: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiUserPermissionResponse {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  permissionCode:
    | "people.view_all"
    | "people.view_selected"
    | "cases.create"
    | "cases.view_all"
    | "cases.manage"
    | "documents.manage_limited"
    | "documents.manage"
    | "members.manage_lifecycle"
    | "settings.manage"
    | "analytics.view";
  /* Template custom: data-contract-jsdoc */
  isGranted: boolean;
  /* Template custom: data-contract-jsdoc */
  grantedAt: string;
  /* Template custom: data-contract-jsdoc */
  expiresAt?: string | null;
  /* Template custom: data-contract-jsdoc */
  reason?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiChatPermissionResponse {
  /* Template custom: data-contract-jsdoc */
  canInitiateWithAll: boolean;
  /* Template custom: data-contract-jsdoc */
  allowedProfileIds: number[];
  /* Template custom: data-contract-jsdoc */
  allowedTagCodes: (
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
  )[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUpdateChatPermissionsDto {
  /* Template custom: data-contract-jsdoc */
  canInitiateWithAll: boolean;
  /* Template custom: data-contract-jsdoc */
  allowedProfileIds?: number[];
  /* Template custom: data-contract-jsdoc */
  allowedTagCodes?: (
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
  )[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiUserSummary {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskSummary {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  priority?: "LOW" | "MEDIUM" | "HIGH" | "URGENT" | null;
  /* Template custom: data-contract-jsdoc */
  status?: "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED" | null;
  /* Template custom: data-contract-jsdoc */
  assignee?: ApiUserSummary | null;
  /* Template custom: data-contract-jsdoc */
  caseId: string;
  /* Template custom: data-contract-jsdoc */
  caseName?: string | null;
  /* Template custom: data-contract-jsdoc */
  dueDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskListData {
  /* Template custom: data-contract-jsdoc */
  tasks: ApiTaskSummary[];
  /* Template custom: data-contract-jsdoc */
  totalCount: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaskManagerWidget {
  /* Template custom: data-contract-jsdoc */
  assignedToMe: ApiTaskListData;
  /* Template custom: data-contract-jsdoc */
  createdByMe: ApiTaskListData;
  /* Template custom: data-contract-jsdoc */
  isEmpty: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAnalyticsOverviewWidget {
  /* Template custom: data-contract-jsdoc */
  kpi: ApiKpiData;
  /* Template custom: data-contract-jsdoc */
  charts: ApiChartsData;
  /* Template custom: data-contract-jsdoc */
  isEmpty: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMemberSummaryV2 {
  /* Template custom: data-contract-jsdoc */
  profileId: number;
  /* Template custom: data-contract-jsdoc */
  firstName?: string | null;
  /* Template custom: data-contract-jsdoc */
  lastName?: string | null;
  /* Template custom: data-contract-jsdoc */
  email: string;
  /* Template custom: data-contract-jsdoc */
  tagCode?:
    | "FAMILY"
    | "LEGAL"
    | "WEALTH"
    | "TAX"
    | "FINANCE"
    | "MANAGEMENT"
    | "LIFESTYLE"
    | null;
  /* Template custom: data-contract-jsdoc */
  countryCode?:
    | "AC"
    | "AD"
    | "AE"
    | "AF"
    | "AG"
    | "AI"
    | "AL"
    | "AM"
    | "AO"
    | "AQ"
    | "AR"
    | "AS"
    | "AT"
    | "AU"
    | "AW"
    | "AX"
    | "AZ"
    | "BA"
    | "BB"
    | "BD"
    | "BE"
    | "BF"
    | "BG"
    | "BH"
    | "BI"
    | "BJ"
    | "BL"
    | "BM"
    | "BN"
    | "BO"
    | "BQ"
    | "BR"
    | "BS"
    | "BT"
    | "BW"
    | "BY"
    | "BZ"
    | "CA"
    | "CC"
    | "CD"
    | "CF"
    | "CG"
    | "CH"
    | "CI"
    | "CK"
    | "CL"
    | "CM"
    | "CN"
    | "CO"
    | "CR"
    | "CU"
    | "CV"
    | "CW"
    | "CX"
    | "CY"
    | "CZ"
    | "DE"
    | "DJ"
    | "DK"
    | "DM"
    | "DO"
    | "DZ"
    | "EC"
    | "EE"
    | "EG"
    | "EH"
    | "ER"
    | "ES"
    | "ET"
    | "FI"
    | "FJ"
    | "FK"
    | "FM"
    | "FO"
    | "FR"
    | "GA"
    | "GB"
    | "GD"
    | "GE"
    | "GF"
    | "GG"
    | "GH"
    | "GI"
    | "GL"
    | "GM"
    | "GN"
    | "GP"
    | "GQ"
    | "GR"
    | "GS"
    | "GT"
    | "GU"
    | "GW"
    | "GY"
    | "HK"
    | "HM"
    | "HN"
    | "HR"
    | "HT"
    | "HU"
    | "ID"
    | "IE"
    | "IL"
    | "IM"
    | "IN"
    | "IO"
    | "IQ"
    | "IR"
    | "IS"
    | "IT"
    | "JE"
    | "JM"
    | "JO"
    | "JP"
    | "KE"
    | "KG"
    | "KH"
    | "KI"
    | "KM"
    | "KN"
    | "KP"
    | "KR"
    | "KW"
    | "KY"
    | "KZ"
    | "LA"
    | "LB"
    | "LC"
    | "LI"
    | "LK"
    | "LR"
    | "LS"
    | "LT"
    | "LU"
    | "LV"
    | "LY"
    | "MA"
    | "MC"
    | "MD"
    | "ME"
    | "MF"
    | "MG"
    | "MH"
    | "MK"
    | "ML"
    | "MM"
    | "MN"
    | "MO"
    | "MP"
    | "MQ"
    | "MR"
    | "MS"
    | "MT"
    | "MU"
    | "MV"
    | "MW"
    | "MX"
    | "MY"
    | "MZ"
    | "NA"
    | "NC"
    | "NE"
    | "NF"
    | "NG"
    | "NI"
    | "NL"
    | "NO"
    | "NP"
    | "NR"
    | "NU"
    | "NZ"
    | "OM"
    | "PA"
    | "PE"
    | "PF"
    | "PG"
    | "PH"
    | "PK"
    | "PL"
    | "PM"
    | "PN"
    | "PR"
    | "PS"
    | "PT"
    | "PW"
    | "PY"
    | "QA"
    | "RE"
    | "RO"
    | "RS"
    | "RU"
    | "RW"
    | "SA"
    | "SB"
    | "SC"
    | "SD"
    | "SE"
    | "SG"
    | "SH"
    | "SI"
    | "SJ"
    | "SK"
    | "SL"
    | "SM"
    | "SN"
    | "SO"
    | "SR"
    | "SS"
    | "ST"
    | "SV"
    | "SX"
    | "SY"
    | "SZ"
    | "TA"
    | "TC"
    | "TD"
    | "TF"
    | "TG"
    | "TH"
    | "TJ"
    | "TK"
    | "TL"
    | "TM"
    | "TN"
    | "TO"
    | "TR"
    | "TT"
    | "TV"
    | "TW"
    | "TZ"
    | "UA"
    | "UG"
    | "UM"
    | "US"
    | "UY"
    | "UZ"
    | "VA"
    | "VC"
    | "VE"
    | "VG"
    | "VI"
    | "VN"
    | "VU"
    | "WF"
    | "WS"
    | "XK"
    | "YE"
    | "YT"
    | "ZA"
    | "ZM"
    | "ZW"
    | null;
  /* Template custom: data-contract-jsdoc */
  isOnline: boolean;
  /* Template custom: data-contract-jsdoc */
  lastActiveDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  status: "AWAIT_AUTHORISATION" | "REGISTERED";
}

/* Template custom: data-contract-jsdoc */
export interface ApiMembersKpiData {
  /* Template custom: data-contract-jsdoc */
  totalMembers: number;
  /* Template custom: data-contract-jsdoc */
  activeNow: number;
  /* Template custom: data-contract-jsdoc */
  inactive7Days: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiInvitationBreakdownData {
  /* Template custom: data-contract-jsdoc */
  invited: number;
  /* Template custom: data-contract-jsdoc */
  registered: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMembersChartsData {
  /* Template custom: data-contract-jsdoc */
  invitationBreakdown: ApiInvitationBreakdownData;
  /* Template custom: data-contract-jsdoc */
  tagDistribution: Record<string, number>;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMembersAnalytics {
  /* Template custom: data-contract-jsdoc */
  kpi: ApiMembersKpiData;
  /* Template custom: data-contract-jsdoc */
  charts: ApiMembersChartsData;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAllMembersWidgetV2 {
  /* Template custom: data-contract-jsdoc */
  members: ApiMemberSummaryV2[];
  /* Template custom: data-contract-jsdoc */
  totalCount: number;
  /* Template custom: data-contract-jsdoc */
  analytics: ApiMembersAnalytics;
  /* Template custom: data-contract-jsdoc */
  isEmpty: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentSummary {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  fileName: string;
  /* Template custom: data-contract-jsdoc */
  fileType: string;
  /* Template custom: data-contract-jsdoc */
  fileSizeBytes: number;
  /* Template custom: data-contract-jsdoc */
  isNew: boolean;
  /* Template custom: data-contract-jsdoc */
  addedBy: ApiUserSummary;
  /* Template custom: data-contract-jsdoc */
  addedAt: string;
  /* Template custom: data-contract-jsdoc */
  caseId?: string | null;
  /* Template custom: data-contract-jsdoc */
  caseName?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentsKpiData {
  /* Template custom: data-contract-jsdoc */
  totalDocuments: number;
  /* Template custom: data-contract-jsdoc */
  newDocuments: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentsAnalytics {
  /* Template custom: data-contract-jsdoc */
  kpi: ApiDocumentsKpiData;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAllDocumentsWidget {
  /* Template custom: data-contract-jsdoc */
  documents: ApiDocumentSummary[];
  /* Template custom: data-contract-jsdoc */
  totalCount: number;
  /* Template custom: data-contract-jsdoc */
  analytics: ApiDocumentsAnalytics;
  /* Template custom: data-contract-jsdoc */
  isEmpty: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseSummary {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  title: string;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  background:
    | "GENERAL"
    | "HOUSE"
    | "KEY"
    | "INVOICE"
    | "CERTIFICATE"
    | "USERS"
    | "BUILDINGS"
    | "BANK"
    | "BRIEFCASE"
    | "GLOBE"
    | "ARCHIVE";
  /* Template custom: data-contract-jsdoc */
  isGeneralCase: boolean;
  /* Template custom: data-contract-jsdoc */
  isPrivateCase: boolean;
  /* Template custom: data-contract-jsdoc */
  memberCount: number;
  /* Template custom: data-contract-jsdoc */
  documentCount: number;
  /* Template custom: data-contract-jsdoc */
  taskCount: number;
  /* Template custom: data-contract-jsdoc */
  createdAt: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCasesKpiData {
  /* Template custom: data-contract-jsdoc */
  totalCases: number;
  /* Template custom: data-contract-jsdoc */
  activeCases: number;
  /* Template custom: data-contract-jsdoc */
  emptyCases: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMemberDistributionData {
  /* Template custom: data-contract-jsdoc */
  inCases: number;
  /* Template custom: data-contract-jsdoc */
  notInCases: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCaseContentDistributionData {
  /* Template custom: data-contract-jsdoc */
  tasksAndDocuments: number;
  /* Template custom: data-contract-jsdoc */
  onlyTasks: number;
  /* Template custom: data-contract-jsdoc */
  onlyDocuments: number;
  /* Template custom: data-contract-jsdoc */
  empty: number;
  /* Template custom: data-contract-jsdoc */
  totalCases: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCasesChartsData {
  /* Template custom: data-contract-jsdoc */
  memberDistribution: ApiMemberDistributionData;
  /* Template custom: data-contract-jsdoc */
  caseContentDistribution: ApiCaseContentDistributionData;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCasesAnalytics {
  /* Template custom: data-contract-jsdoc */
  kpi: ApiCasesKpiData;
  /* Template custom: data-contract-jsdoc */
  charts: ApiCasesChartsData;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCasesWidget {
  /* Template custom: data-contract-jsdoc */
  cases: ApiCaseSummary[];
  /* Template custom: data-contract-jsdoc */
  totalCount: number;
  /* Template custom: data-contract-jsdoc */
  analytics: ApiCasesAnalytics;
  /* Template custom: data-contract-jsdoc */
  isEmpty: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDashboardResponseV2 {
  /* Template custom: data-contract-jsdoc */
  taskManager: ApiTaskManagerWidget;
  /* Template custom: data-contract-jsdoc */
  analyticsOverview: ApiAnalyticsOverviewWidget;
  /* Template custom: data-contract-jsdoc */
  allMembers: ApiAllMembersWidgetV2;
  /* Template custom: data-contract-jsdoc */
  allDocuments: ApiAllDocumentsWidget;
  /* Template custom: data-contract-jsdoc */
  cases: ApiCasesWidget;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAddress {
  /* Template custom: data-contract-jsdoc */
  country?: ApiCountry | null;
  /* Template custom: data-contract-jsdoc */
  zipCode?: string | null;
  /* Template custom: data-contract-jsdoc */
  district?: string | null;
  /* Template custom: data-contract-jsdoc */
  city?: string | null;
  /* Template custom: data-contract-jsdoc */
  street?: string | null;
  /* Template custom: data-contract-jsdoc */
  buildingNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  apartment?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetClassification {
  /* Template custom: data-contract-jsdoc */
  brief_visual_summary: string;
  /* Template custom: data-contract-jsdoc */
  visual_cues: string[];
  /* Template custom: data-contract-jsdoc */
  quality_flags?: (
    | "blurry"
    | "glare"
    | "cropped"
    | "rotated"
    | "low_resolution"
    | "partial_page"
    | "watermark_overlay"
    | "obstructed_text"
  )[];
  /* Template custom: data-contract-jsdoc */
  disambiguation_notes?: string | null;
  /* Template custom: data-contract-jsdoc */
  asset_type:
    | "DEBIT_ACCOUNTS"
    | "RESIDENTIAL_REAL_ESTATE"
    | "COMMERCIAL_REAL_ESTATE"
    | "LAND"
    | "LEGAL_ENTITIES"
    | "JEWELLERY"
    | "BANK_CELLS"
    | "METAL_ACCOUNTS"
    | "CENTRALIZED_WALLET"
    | "DECENTRALIZED_WALLET"
    | "PRECIOUS_STONES"
    | "COMMODITY_ASSET_TOKENS"
    | "BROKERAGE_ACCOUNT"
    | "SECURITIES_AND_STOCKS"
    | "BONDS"
    | "EXCHANGE_OPTIONS"
    | "OVER_THE_COUNTER_OPTIONS"
    | "FORWARDS"
    | "FUTURES"
    | "MY_FUND"
    | "PUBLIC_FUND";
  /* Template custom: data-contract-jsdoc */
  confidence: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetExtractResponse {
  /* Template custom: data-contract-jsdoc */
  kind?: string;
  /* Template custom: data-contract-jsdoc */
  asset_type?: string | null;
  /* Template custom: data-contract-jsdoc */
  data?: Record<string, any> | null;
  /* Template custom: data-contract-jsdoc */
  personal_documents?: ApiPersonalDocumentsPayload | null;
  /* Template custom: data-contract-jsdoc */
  contacts?: ApiContactDto[] | null;
  /* Template custom: data-contract-jsdoc */
  file_ids?: string[] | null;
  /* Template custom: data-contract-jsdoc */
  document_count?: number;
  /* Template custom: data-contract-jsdoc */
  error?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetExtractUriItem {
  /* Template custom: data-contract-jsdoc */
  file_id: string;
  /* Template custom: data-contract-jsdoc */
  content_uri: string;
  /* Template custom: data-contract-jsdoc */
  mime?: string | null;
  /* Template custom: data-contract-jsdoc */
  symmetric_key?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAssetInformationDocumentDto {
  /* Template custom: data-contract-jsdoc */
  commentaryOnAsset?: string | null;
  /* Template custom: data-contract-jsdoc */
  identificationNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  assetAcquireDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  assetExpiresOn?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBankCell {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiBankCellType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  isCashStorage?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  isOtherValuables?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  otherValuables?: string | null;
  /* Template custom: data-contract-jsdoc */
  isDocuments?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  accessMethod?: ApiBankCellAccessMethod | null;
  /* Template custom: data-contract-jsdoc */
  keyStorageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositBoxAddress?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositBoxNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositBoxSize?: string | null;
  /* Template custom: data-contract-jsdoc */
  openingDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  validUntil?: string | null;
  /* Template custom: data-contract-jsdoc */
  specialAccessConditions?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  specialAccessConditionsComment?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchByUriInput {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  items: ApiBatchUriItem[];
  /* Template custom: data-contract-jsdoc */
  file_ids?: string[] | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchStartResponse {
  /* Template custom: data-contract-jsdoc */
  job_id: string;
  /* Template custom: data-contract-jsdoc */
  total: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBatchUriItem {
  /* Template custom: data-contract-jsdoc */
  file_id: string;
  /* Template custom: data-contract-jsdoc */
  content_uri: string;
  /* Template custom: data-contract-jsdoc */
  mime?: string | null;
  /* Template custom: data-contract-jsdoc */
  symmetric_key?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBirthCertificateDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  fullBirthName?: string | null;
  /* Template custom: data-contract-jsdoc */
  birthDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuedBy?: string | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  parent1?: string | null;
  /* Template custom: data-contract-jsdoc */
  parent2?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBodyFamilyCassaPaymentFromPdfFamilyCassaPaymentFromPdfPost {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  file: File;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBodyHttpExtractAssetFromFilesExtractAssetFromFilesPost {
  /* Template custom: data-contract-jsdoc */
  files: File[];
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  file_ids?: string | null;
  /* Template custom: data-contract-jsdoc */
  asset_type_hint?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBodyHttpExtractBatchExtractBatchPost {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  files: File[];
  /* Template custom: data-contract-jsdoc */
  file_ids?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBodyHttpExtractFromImagesExtractFromImagesPost {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  files: File[];
  /* Template custom: data-contract-jsdoc */
  enqueue?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  file_ids?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBond {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiBondsEnum | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  keyAssets?: string | null;
  /* Template custom: data-contract-jsdoc */
  keyAssetsQuantity?: number | null;
  /* Template custom: data-contract-jsdoc */
  currentMarketValue?: number | null;
  /* Template custom: data-contract-jsdoc */
  issuedBy?: string | null;
  /* Template custom: data-contract-jsdoc */
  isin?: string | null;
  /* Template custom: data-contract-jsdoc */
  acquisitionDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  maturityDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  brokerageAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositaryName?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositaryAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradeType?: ApiTradeType | null;
  /* Template custom: data-contract-jsdoc */
  seller?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradingPlatform?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  secured?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  bondsType?: ApiBondType | null;
  /* Template custom: data-contract-jsdoc */
  bondsRate?: ApiRatingType | null;
  /* Template custom: data-contract-jsdoc */
  strategy?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiBrokerageAccount {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  keyAssets?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherKeyAssets?: string | null;
  /* Template custom: data-contract-jsdoc */
  availableLimit?: number | null;
  /* Template custom: data-contract-jsdoc */
  totalBalance?: number | null;
  /* Template custom: data-contract-jsdoc */
  plannedProfitability?: number | null;
  /* Template custom: data-contract-jsdoc */
  actualProfitability?: number | null;
  /* Template custom: data-contract-jsdoc */
  commissions?: number | null;
  /* Template custom: data-contract-jsdoc */
  expenses?: number | null;
  /* Template custom: data-contract-jsdoc */
  totalExpenses?: number | null;
  /* Template custom: data-contract-jsdoc */
  tradingPlatforms?: string | null;
  /* Template custom: data-contract-jsdoc */
  cif?: string | null;
  /* Template custom: data-contract-jsdoc */
  iban?: string | null;
  /* Template custom: data-contract-jsdoc */
  openingDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  marginPosition?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  marginPositionAvailableLimit?: string | null;
  /* Template custom: data-contract-jsdoc */
  blocking?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  blockingReason?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherBlockingReason?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategyDescription?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCentralizedWallet {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  assetsInWallet?: ApiCurrenciesType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  holder?: string | null;
  /* Template custom: data-contract-jsdoc */
  accountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  loginStorageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  kyc?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCommercialRealEstate {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiCommercialRealEstateType | null;
  /* Template custom: data-contract-jsdoc */
  otherType?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  district: string;
  /* Template custom: data-contract-jsdoc */
  addressLabel?: string | null;
  /* Template custom: data-contract-jsdoc */
  zipCode: string;
  /* Template custom: data-contract-jsdoc */
  city: string;
  /* Template custom: data-contract-jsdoc */
  street: string;
  /* Template custom: data-contract-jsdoc */
  buildingNumber: string;
  /* Template custom: data-contract-jsdoc */
  unitOfficeNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  commercialRealEstateNumberName?: string | null;
  /* Template custom: data-contract-jsdoc */
  commercialRealEstateNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  commencementDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  areaOfTheApartments?: number | null;
  /* Template custom: data-contract-jsdoc */
  compositionOfObjects?: string | null;
  /* Template custom: data-contract-jsdoc */
  landPlot?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  landPlotSquare?: number | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiCommodityAssetToken {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  baseAssetType?: ApiBaseAssetType | null;
  /* Template custom: data-contract-jsdoc */
  otherBaseAssetType?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  quantity?: number | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetSpecificity?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuer?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherIssuer?: string | null;
  /* Template custom: data-contract-jsdoc */
  identifierName?: string | null;
  /* Template custom: data-contract-jsdoc */
  identifierNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue2?: number | null;
  /* Template custom: data-contract-jsdoc */
  investmentStartDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  investmentEndDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  contractSpecialConditions?: string | null;
  /* Template custom: data-contract-jsdoc */
  isTransferableToThirdParty?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  issuerLabelInfo?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuerLegalName?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuerLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  headCompanyLegalName?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetPlaceOfStorage?: string | null;
  /* Template custom: data-contract-jsdoc */
  addExchangePlatform?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  exchangePlatform?: ApiIssuerAndExchangePlatformType | null;
  /* Template custom: data-contract-jsdoc */
  exchangePlatformInformationSystemOperator?: string | null;
  /* Template custom: data-contract-jsdoc */
  exchangePlatformBank?: string | null;
  /* Template custom: data-contract-jsdoc */
  exchangePlatformLegalEntity?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherExchangePlatform?: string | null;
  /* Template custom: data-contract-jsdoc */
  placeOfRecordOther?: string | null;
  /* Template custom: data-contract-jsdoc */
  placeOfRecordOtherDetails?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiContactDto {
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  name?: string | null;
  /* Template custom: data-contract-jsdoc */
  lasName?: string | null;
  /* Template custom: data-contract-jsdoc */
  selectedCountry: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type: ApiContactType;
  /* Template custom: data-contract-jsdoc */
  phone?: ApiAppLlmSchemasContactContactPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
  /* Template custom: data-contract-jsdoc */
  address?: string | null;
  /* Template custom: data-contract-jsdoc */
  organization?: string | null;
  /* Template custom: data-contract-jsdoc */
  position?: string | null;
  /* Template custom: data-contract-jsdoc */
  commentary?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDebitAccount {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiDebitType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  bank?: string | null;
  /* Template custom: data-contract-jsdoc */
  cif?: string | null;
  /* Template custom: data-contract-jsdoc */
  iban?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfOpening?: string | null;
  /* Template custom: data-contract-jsdoc */
  fixedTermAccount?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  activeUntil?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDecentralizedWallet {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  assetsInWallet: ApiCurrenciesType;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  walletType: ApiCryptoWalletType;
  /* Template custom: data-contract-jsdoc */
  mnemonicStorageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  officialWalletName?: string | null;
  /* Template custom: data-contract-jsdoc */
  deviceStorageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  loginStorageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDocumentExtractByUriInput {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  items: ApiAssetExtractUriItem[];
  /* Template custom: data-contract-jsdoc */
  kind?: string | null;
  /* Template custom: data-contract-jsdoc */
  subtype_hint?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiDriverLicenseDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  category?: ApiCategoryType | null;
  /* Template custom: data-contract-jsdoc */
  otherCategory?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiEducationDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  educationalInstitutionName?: string | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  startDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  obtainingDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiExchangeOptions {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiExchangeOptionsType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  basicAssetName?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetType?: ApiBasicAssetType | null;
  /* Template custom: data-contract-jsdoc */
  otherBasicAssetType?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetAmount?: number | null;
  /* Template custom: data-contract-jsdoc */
  broker?: string | null;
  /* Template custom: data-contract-jsdoc */
  buyingPrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  strikePrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  exchangeName?: string | null;
  /* Template custom: data-contract-jsdoc */
  optionStyle?: ApiOptionStyleType | null;
  /* Template custom: data-contract-jsdoc */
  otherOptionStyle?: string | null;
  /* Template custom: data-contract-jsdoc */
  optionPeriod?: number | null;
  /* Template custom: data-contract-jsdoc */
  sellerName?: string | null;
  /* Template custom: data-contract-jsdoc */
  sellerDetails?: string | null;
  /* Template custom: data-contract-jsdoc */
  brokerAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReserves?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReservesData?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategyBasicPosition?: ApiStrategyBasicPositionType | null;
  /* Template custom: data-contract-jsdoc */
  strategyDescription?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export type ApiExtractFromImagesResponse =
  | ApiExtractResponse
  | ApiBatchStartResponse;

/* Template custom: data-contract-jsdoc */
export interface ApiExtractItem {
  /* Template custom: data-contract-jsdoc */
  kind: string;
  /* Template custom: data-contract-jsdoc */
  asset_type?: string | null;
  /* Template custom: data-contract-jsdoc */
  id_type?: string | null;
  /* Template custom: data-contract-jsdoc */
  data?:
    | ApiDebitAccount
    | ApiResidentialRealEstate
    | ApiCommercialRealEstate
    | ApiLand
    | ApiLegalEntity
    | ApiJewelry
    | ApiBankCell
    | ApiMetalAccount
    | ApiCentralizedWallet
    | ApiDecentralizedWallet
    | ApiPreciousGemstones
    | ApiCommodityAssetToken
    | ApiBrokerageAccount
    | ApiSecuritiesAndStocks
    | ApiBond
    | ApiExchangeOptions
    | ApiOverTheCounterOptions
    | ApiFutures
    | ApiForwards
    | ApiMyFund
    | ApiPublicFund
    | ApiPassportDtoType
    | ApiNationalIDDtoType
    | ApiDriverLicenseDtoType
    | ApiBirthCertificateDtoType
    | ApiResidencePermitDtoType
    | ApiMedicalIDDtoType
    | ApiMilitaryIDDtoType
    | ApiSocialSecurityDtoType
    | ApiTaxIDDtoType
    | ApiEducationDtoType
    | ApiSubstanceDtoType
    | ApiIDDocumentClassification
    | ApiMixedClassification
    | null;
  /* Template custom: data-contract-jsdoc */
  error?: string | null;
  /* Template custom: data-contract-jsdoc */
  personal_documents?: ApiPersonalDocumentsPayload | null;
  /* Template custom: data-contract-jsdoc */
  contacts?: ApiContactDto[] | null;
  /* Template custom: data-contract-jsdoc */
  file_id?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiExtractResponse {
  /* Template custom: data-contract-jsdoc */
  results: ApiExtractItem[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaExecutePaymentRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  force_execute?: boolean;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaExecutePaymentResponse {
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  channel?: string | null;
  /* Template custom: data-contract-jsdoc */
  jurisdiction?: string | null;
  /* Template custom: data-contract-jsdoc */
  scheduled_for?: number | null;
  /* Template custom: data-contract-jsdoc */
  executed_at?: number | null;
  /* Template custom: data-contract-jsdoc */
  reason?: string | null;
  /* Template custom: data-contract-jsdoc */
  provider?: string | null;
  /* Template custom: data-contract-jsdoc */
  provider_reference?: string | null;
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaPaymentFromPdfResponse {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  debug?: ApiFamilyCassaPdfIngestDebugDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaPaymentFromTextRequest {
  /* Template custom: data-contract-jsdoc */
  invoice_text: string;
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaPaymentResponse {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaPdfIngestDebugDto {
  /* Template custom: data-contract-jsdoc */
  mode: "text" | "vision";
  /* Template custom: data-contract-jsdoc */
  pages: ApiFamilyCassaPdfIngestPageDto[];
  /* Template custom: data-contract-jsdoc */
  length?: number | null;
  /* Template custom: data-contract-jsdoc */
  images_count?: number | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaPdfIngestPageDto {
  /* Template custom: data-contract-jsdoc */
  page: number;
  /* Template custom: data-contract-jsdoc */
  mode: "text" | "vision";
  /* Template custom: data-contract-jsdoc */
  text_length?: number | null;
  /* Template custom: data-contract-jsdoc */
  text_preview?: string | null;
  /* Template custom: data-contract-jsdoc */
  image_b64_length?: number | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaRoutingApprovalRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaRoutingApprovalResponse {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateRecipientAbaRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  profile_id?: number | null;
  /* Template custom: data-contract-jsdoc */
  legal_type?: "PRIVATE" | "BUSINESS";
  /* Template custom: data-contract-jsdoc */
  routing_number: string;
  /* Template custom: data-contract-jsdoc */
  account_number: string;
  /* Template custom: data-contract-jsdoc */
  account_type?: "CHECKING" | "SAVINGS";
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
  /* Template custom: data-contract-jsdoc */
  address: ApiFamilyCassaWiseRecipientAddressUS;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateRecipientIbanRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  profile_id?: number | null;
  /* Template custom: data-contract-jsdoc */
  currency?: string | null;
  /* Template custom: data-contract-jsdoc */
  legal_type?: "PRIVATE" | "BUSINESS";
  /* Template custom: data-contract-jsdoc */
  address: ApiFamilyCassaWiseRecipientAddress;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateRecipientResponse {
  /* Template custom: data-contract-jsdoc */
  recipient_id: number;
  /* Template custom: data-contract-jsdoc */
  recipient: ApiWiseRecipientDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateRecipientSwiftRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  profile_id?: number | null;
  /* Template custom: data-contract-jsdoc */
  legal_type?: "PRIVATE" | "BUSINESS";
  /* Template custom: data-contract-jsdoc */
  currency: string;
  /* Template custom: data-contract-jsdoc */
  swift_code?: string | null;
  /* Template custom: data-contract-jsdoc */
  account_number: string;
  /* Template custom: data-contract-jsdoc */
  country_code?: string | null;
  /* Template custom: data-contract-jsdoc */
  address: ApiFamilyCassaWiseRecipientAddress;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateTransferRequest {
  /* Template custom: data-contract-jsdoc */
  quote_id: string;
  /* Template custom: data-contract-jsdoc */
  recipient_id: number;
  /* Template custom: data-contract-jsdoc */
  reference: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseCreateTransferResponse {
  /* Template custom: data-contract-jsdoc */
  transfer_id: number;
  /* Template custom: data-contract-jsdoc */
  transfer: ApiWiseTransferDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseDepositDetailsRequest {
  /* Template custom: data-contract-jsdoc */
  profile_id: number;
  /* Template custom: data-contract-jsdoc */
  transfer_id: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseDepositDetailsResponse {
  /* Template custom: data-contract-jsdoc */
  deposit_details: ApiWiseDepositDetailsDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseFundTransferRequest {
  /* Template custom: data-contract-jsdoc */
  profile_id: number;
  /* Template custom: data-contract-jsdoc */
  transfer_id: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseFundTransferResponse {
  /* Template custom: data-contract-jsdoc */
  payment: ApiWiseFundingDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWisePatchQuoteRequest {
  /* Template custom: data-contract-jsdoc */
  profile_id: number;
  /* Template custom: data-contract-jsdoc */
  quote_id: string;
  /* Template custom: data-contract-jsdoc */
  recipient_id: number;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWisePatchQuoteResponse {
  /* Template custom: data-contract-jsdoc */
  quote: ApiWiseQuoteDto;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWisePrepareRequest {
  /* Template custom: data-contract-jsdoc */
  payment: ApiPaymentEntity;
  /* Template custom: data-contract-jsdoc */
  source_currency?: string | null;
  /* Template custom: data-contract-jsdoc */
  target_currency?: string | null;
  /* Template custom: data-contract-jsdoc */
  amount?: number | null;
  /* Template custom: data-contract-jsdoc */
  amount_type?: "source" | "target";
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWisePrepareResponse {
  /* Template custom: data-contract-jsdoc */
  provider?: string;
  /* Template custom: data-contract-jsdoc */
  profile_id: number;
  /* Template custom: data-contract-jsdoc */
  quote_id: string;
  /* Template custom: data-contract-jsdoc */
  quote: ApiWiseQuoteDto;
  /* Template custom: data-contract-jsdoc */
  account_requirements?: ApiWiseRequirementsDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseRecipientAddress {
  /* Template custom: data-contract-jsdoc */
  city: string;
  /* Template custom: data-contract-jsdoc */
  post_code: string;
  /* Template custom: data-contract-jsdoc */
  first_line: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFamilyCassaWiseRecipientAddressUS {
  /* Template custom: data-contract-jsdoc */
  city: string;
  /* Template custom: data-contract-jsdoc */
  post_code: string;
  /* Template custom: data-contract-jsdoc */
  first_line: string;
  /* Template custom: data-contract-jsdoc */
  state: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiForwards {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiForwardsType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  basicAssetName: string;
  /* Template custom: data-contract-jsdoc */
  basicAssetType?: ApiBasicAssetType | null;
  /* Template custom: data-contract-jsdoc */
  otherBasicAssetType?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetAmount?: number | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetHolder?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicPrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  expirationDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  seller?: ApiSellerType | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityName?: string | null;
  /* Template custom: data-contract-jsdoc */
  personFullName?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReserves?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReservesData?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategy?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiFutures {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiFuturesType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  basicAssetName: string;
  /* Template custom: data-contract-jsdoc */
  basicAssetType?: ApiBasicAssetType | null;
  /* Template custom: data-contract-jsdoc */
  otherBasicAssetType?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetAmount: number;
  /* Template custom: data-contract-jsdoc */
  broker?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicPrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  brokerAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradeDirection?: ApiTradeDirectionType | null;
  /* Template custom: data-contract-jsdoc */
  expirationDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  marginCollateral?: string | null;
  /* Template custom: data-contract-jsdoc */
  exchangeName: string;
  /* Template custom: data-contract-jsdoc */
  seller?: ApiSellerType | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityName?: string | null;
  /* Template custom: data-contract-jsdoc */
  personFullName?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReserves?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReservesData?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategy?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiHTTPValidationError {
  /* Template custom: data-contract-jsdoc */
  detail?: ApiValidationError[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiIDDocumentClassification {
  /* Template custom: data-contract-jsdoc */
  brief_visual_summary: string;
  /* Template custom: data-contract-jsdoc */
  visual_cues: (
    | "mrz"
    | "passport_layout"
    | "id_card_layout"
    | "stamp_or_seal"
    | "barcode_or_qr"
    | "hologram"
    | "address_block"
    | "gov_emblem"
    | "signature_block"
    | "typed_form_fields"
    | "handwritten_fields"
    | "other"
  )[];
  /* Template custom: data-contract-jsdoc */
  quality_flags?: (
    | "blurry"
    | "glare"
    | "cropped"
    | "rotated"
    | "low_resolution"
    | "partial_page"
    | "watermark_overlay"
    | "obstructed_text"
  )[];
  /* Template custom: data-contract-jsdoc */
  disambiguation_notes?: string | null;
  /* Template custom: data-contract-jsdoc */
  document_type:
    | "CITIZENSHIP_CERTIFICATE"
    | "PASSPORT"
    | "NATIONAL_ID"
    | "BIRTH_CERTIFICATE"
    | "RESIDENCE_PERMIT"
    | "TAX_ID"
    | "DRIVER_LICENSE"
    | "INTERNATIONAL_DRIVER_LICENSE"
    | "EDUCATION"
    | "MEDICAL_ID"
    | "SOCIAL_SECURITY"
    | "MILITARY_ID"
    | "SUBSTANCE"
    | "PERSONAL_CONTACTS"
    | "USER_DETAILS"
    | "FREE_BLOCK";
  /* Template custom: data-contract-jsdoc */
  confidence: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiJewelry {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiJewelryType | null;
  /* Template custom: data-contract-jsdoc */
  otherType?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  kind: ApiJewelryTypeName;
  /* Template custom: data-contract-jsdoc */
  brand?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  collection?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  collectionName?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseAmount?: number | null;
  /* Template custom: data-contract-jsdoc */
  independentAppraisalAmount?: number | null;
  /* Template custom: data-contract-jsdoc */
  metal?: ApiMetalType | null;
  /* Template custom: data-contract-jsdoc */
  otherMetal?: string | null;
  /* Template custom: data-contract-jsdoc */
  preciousGemstones?: ApiPreciousGemstonesType | null;
  /* Template custom: data-contract-jsdoc */
  otherPreciousGemstones?: string | null;
  /* Template custom: data-contract-jsdoc */
  preciousGemstonesWeight?: number | null;
  /* Template custom: data-contract-jsdoc */
  preciousGemstonesColor?: string | null;
  /* Template custom: data-contract-jsdoc */
  serialNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  acquisitionDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  receipt?: string | null;
  /* Template custom: data-contract-jsdoc */
  paymentMethod?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  registrationInBrandDatabase?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  itemCondition?: ApiItemConditionType | null;
  /* Template custom: data-contract-jsdoc */
  defects?: string | null;
  /* Template custom: data-contract-jsdoc */
  historyOfOrigin?: string | null;
  /* Template custom: data-contract-jsdoc */
  typeOfHistoryOfOrigin?: ApiTypeOfHistoryOfOriginType | null;
  /* Template custom: data-contract-jsdoc */
  otherTypeOfHistoryOfOrigin?: string | null;
  /* Template custom: data-contract-jsdoc */
  occasion?: string | null;
  /* Template custom: data-contract-jsdoc */
  source?: string | null;
  /* Template custom: data-contract-jsdoc */
  photo?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiJobDocument {
  /* Template custom: data-contract-jsdoc */
  job_id: string;
  /* Template custom: data-contract-jsdoc */
  status: string;
  /* Template custom: data-contract-jsdoc */
  total: number;
  /* Template custom: data-contract-jsdoc */
  done: number;
  /* Template custom: data-contract-jsdoc */
  errors: ApiJobError[];
  /* Template custom: data-contract-jsdoc */
  results: ApiJobResultEntry[];
  /* Template custom: data-contract-jsdoc */
  meta: ApiJobMeta;
  /* Template custom: data-contract-jsdoc */
  created_at: number;
  /* Template custom: data-contract-jsdoc */
  pending_indexes?: number[] | null;
  /* Template custom: data-contract-jsdoc */
  pending_file_ids?: string[] | null;
  /* Template custom: data-contract-jsdoc */
  pending_stale_indexes?: number[] | null;
  /* Template custom: data-contract-jsdoc */
  pending_stale_file_ids?: string[] | null;
  /* Template custom: data-contract-jsdoc */
  pending_timeout_seconds?: number | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiJobError {
  /* Template custom: data-contract-jsdoc */
  error: string;
  /* Template custom: data-contract-jsdoc */
  index: number;
  /* Template custom: data-contract-jsdoc */
  file_id?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiJobListResponse {
  /* Template custom: data-contract-jsdoc */
  job_ids?: string[];
  /* Template custom: data-contract-jsdoc */
  jobs?: ApiJobDocument[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiJobMeta {
  /* Template custom: data-contract-jsdoc */
  model?: string | null;
  /* Template custom: data-contract-jsdoc */
  file_ids?: string[] | null;
  /* Template custom: data-contract-jsdoc */
  user_sub?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiJobResultEntry {
  /* Template custom: data-contract-jsdoc */
  file_id?: string | null;
  /* Template custom: data-contract-jsdoc */
  results: ApiExtractItem[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiLand {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  district: string;
  /* Template custom: data-contract-jsdoc */
  addressLabel?: string | null;
  /* Template custom: data-contract-jsdoc */
  index: string;
  /* Template custom: data-contract-jsdoc */
  city: string;
  /* Template custom: data-contract-jsdoc */
  street: string;
  /* Template custom: data-contract-jsdoc */
  buildingNumber: string;
  /* Template custom: data-contract-jsdoc */
  numberName?: string | null;
  /* Template custom: data-contract-jsdoc */
  number?: number | null;
  /* Template custom: data-contract-jsdoc */
  commencementDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  landArea?: number | null;
  /* Template custom: data-contract-jsdoc */
  permittedUse?: ApiPermittedUseType | null;
  /* Template custom: data-contract-jsdoc */
  compositionOfObjects?: string | null;
  /* Template custom: data-contract-jsdoc */
  buildingInformationOnTheLandPlot?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiLegalEntity {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  entityType?: ApiActivityType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  legalName: string;
  /* Template custom: data-contract-jsdoc */
  formOfOrganization?: string | null;
  /* Template custom: data-contract-jsdoc */
  structure?: string | null;
  /* Template custom: data-contract-jsdoc */
  typeOfBusiness?: string | null;
  /* Template custom: data-contract-jsdoc */
  portfolioCurrency?: string | null;
  /* Template custom: data-contract-jsdoc */
  plannedDividends?: number | null;
  /* Template custom: data-contract-jsdoc */
  actualDividends?: number | null;
  /* Template custom: data-contract-jsdoc */
  dividendsDelta?: number | null;
  /* Template custom: data-contract-jsdoc */
  dividendTaxAgent?: ApiTaxAgentType | null;
  /* Template custom: data-contract-jsdoc */
  otherDividendTaxAgent?: string | null;
  /* Template custom: data-contract-jsdoc */
  isCompanyHasLimitations?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  companyLimitationsComment?: string | null;
  /* Template custom: data-contract-jsdoc */
  isShareholderHasLimitations?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  shareholderLimitationsComment?: string | null;
  /* Template custom: data-contract-jsdoc */
  usageProfile?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIncorporation?: number | null;
  /* Template custom: data-contract-jsdoc */
  taxNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  taxNumberIssuedBy?: string | null;
  /* Template custom: data-contract-jsdoc */
  lei?: string | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityAddress?: string | null;
  /* Template custom: data-contract-jsdoc */
  province?: string | null;
  /* Template custom: data-contract-jsdoc */
  zipCode?: string | null;
  /* Template custom: data-contract-jsdoc */
  city?: string | null;
  /* Template custom: data-contract-jsdoc */
  street?: string | null;
  /* Template custom: data-contract-jsdoc */
  buildingNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  apartment?: string | null;
  /* Template custom: data-contract-jsdoc */
  addressComment?: string | null;
  /* Template custom: data-contract-jsdoc */
  powersComments?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMedicalIDDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMetalAccount {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiMetalAccountType | null;
  /* Template custom: data-contract-jsdoc */
  otherType?: string | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  currentMarketValue?: number | null;
  /* Template custom: data-contract-jsdoc */
  cif?: string | null;
  /* Template custom: data-contract-jsdoc */
  iban?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfOpening?: string | null;
  /* Template custom: data-contract-jsdoc */
  fixedTermAccount?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  activeUntil?: string | null;
  /* Template custom: data-contract-jsdoc */
  metalQuantity?: number | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMilitaryIDDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMixedClassification {
  /* Template custom: data-contract-jsdoc */
  kind: "id_document" | "asset";
  /* Template custom: data-contract-jsdoc */
  id?: ApiIDDocumentClassification | null;
  /* Template custom: data-contract-jsdoc */
  asset?: ApiAssetClassification | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiMyFund {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiMyFundType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  fullFundName?: string | null;
  /* Template custom: data-contract-jsdoc */
  taskOfTheFund?: ApiTaskOfTheFundType | null;
  /* Template custom: data-contract-jsdoc */
  otherTaskOfTheFund?: string | null;
  /* Template custom: data-contract-jsdoc */
  keyCommitments?: string | null;
  /* Template custom: data-contract-jsdoc */
  typeOfBusiness?: string | null;
  /* Template custom: data-contract-jsdoc */
  organizationLegalForm?: string | null;
  /* Template custom: data-contract-jsdoc */
  fundUsageStrategy?: ApiFundUsageStrategyType | null;
  /* Template custom: data-contract-jsdoc */
  otherFundUsageStrategy?: string | null;
  /* Template custom: data-contract-jsdoc */
  incorporationDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  fundDuration?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  fundDurationDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  prolongation?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  prolongationDate?: number | null;
  /* Template custom: data-contract-jsdoc */
  taxNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  taxNumberIssuedBy?: string | null;
  /* Template custom: data-contract-jsdoc */
  lei?: string | null;
  /* Template custom: data-contract-jsdoc */
  district?: string | null;
  /* Template custom: data-contract-jsdoc */
  zipCode?: string | null;
  /* Template custom: data-contract-jsdoc */
  city?: string | null;
  /* Template custom: data-contract-jsdoc */
  street?: string | null;
  /* Template custom: data-contract-jsdoc */
  buildingNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  apartmentNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherAddressInfo?: string | null;
  /* Template custom: data-contract-jsdoc */
  fundRestrictions?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  fundRestrictionsComments?: string | null;
  /* Template custom: data-contract-jsdoc */
  founderRestrictions?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  founderRestrictionsComments?: string | null;
  /* Template custom: data-contract-jsdoc */
  confidentialityLevel?: ApiConfidentialityLevelType | null;
  /* Template custom: data-contract-jsdoc */
  managementStructure?: ApiManagementStructureType | null;
  /* Template custom: data-contract-jsdoc */
  managementBody?: ApiManagementBodyType | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownershipType?: string | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiNationalIDDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  citizenship?: ApiCountry | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  cardAccessNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiOverTheCounterOptions {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiOverTheCounterOptionsType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  basicAssetName?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherBasicAssetType?: string | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetAmount?: number | null;
  /* Template custom: data-contract-jsdoc */
  basicAssetHolder?: string | null;
  /* Template custom: data-contract-jsdoc */
  buyingPrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  strikePrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  counterpartyType?: string | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityName?: string | null;
  /* Template custom: data-contract-jsdoc */
  personFullName?: string | null;
  /* Template custom: data-contract-jsdoc */
  nominalCost?: number | null;
  /* Template custom: data-contract-jsdoc */
  optionPeriod?: number | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReserves?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  dealReservesData?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategyBasicPosition?: ApiStrategyBasicPositionType | null;
  /* Template custom: data-contract-jsdoc */
  strategyDescription?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPassportDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  citizenship?: ApiCountry | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuedBy?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentEntity {
  /* Template custom: data-contract-jsdoc */
  invoice_number?: string | null;
  /* Template custom: data-contract-jsdoc */
  external_document_id?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_name?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_inn_or_tax_id?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_account?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_swift_bic?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_bank_name?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_country?: string | null;
  /* Template custom: data-contract-jsdoc */
  payee_address?: string | null;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  currency: string;
  /* Template custom: data-contract-jsdoc */
  issue_date?: string | null;
  /* Template custom: data-contract-jsdoc */
  due_date?: string | null;
  /* Template custom: data-contract-jsdoc */
  description?: string | null;
  /* Template custom: data-contract-jsdoc */
  category?: ApiPaymentCategory | null;
  /* Template custom: data-contract-jsdoc */
  priority?: ApiPaymentPriority;
  /* Template custom: data-contract-jsdoc */
  is_mandatory?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  recurrence?: ApiRecurrenceInfo | null;
  /* Template custom: data-contract-jsdoc */
  route_info?: ApiPaymentRouteInfo | null;
  /* Template custom: data-contract-jsdoc */
  can_auto_approve?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  requires_manual_approval?: boolean | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPaymentRouteInfo {
  /* Template custom: data-contract-jsdoc */
  jurisdiction?: "ru" | "non_ru" | "unknown" | null;
  /* Template custom: data-contract-jsdoc */
  preferred_channel?:
    | "wise"
    | "revolut"
    | "stripe"
    | "local_bank"
    | "other"
    | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPersonalDocumentsPayload {
  /* Template custom: data-contract-jsdoc */
  private_document?: ApiPrivateDocumentDto | null;
  /* Template custom: data-contract-jsdoc */
  asset_information?: ApiAssetInformationDocumentDto | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPreciousGemstones {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  type?: ApiPreciousGemstonesType | null;
  /* Template custom: data-contract-jsdoc */
  typeOfOrigin?: ApiTypeOfOrigin | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  weight?: string | null;
  /* Template custom: data-contract-jsdoc */
  countryOfAcquisition: string;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  personalAppraisal?: number | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValueEquivalent?: number | null;
  /* Template custom: data-contract-jsdoc */
  independentAppraisalValue?: number | null;
  /* Template custom: data-contract-jsdoc */
  independentAppraisalValueEquivalent?: number | null;
  /* Template custom: data-contract-jsdoc */
  appraisalLaboratory?: ApiAppraisalLaboratoryType | null;
  /* Template custom: data-contract-jsdoc */
  color?: ApiColorType | null;
  /* Template custom: data-contract-jsdoc */
  otherColor?: string | null;
  /* Template custom: data-contract-jsdoc */
  clarity?: ApiClarityType | null;
  /* Template custom: data-contract-jsdoc */
  otherClarity?: string | null;
  /* Template custom: data-contract-jsdoc */
  enhancements?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  defects?: string | null;
  /* Template custom: data-contract-jsdoc */
  cut?: ApiCutAndPolishType | null;
  /* Template custom: data-contract-jsdoc */
  otherCut?: string | null;
  /* Template custom: data-contract-jsdoc */
  sizes?: string | null;
  /* Template custom: data-contract-jsdoc */
  countryOfOrigin?: string | null;
  /* Template custom: data-contract-jsdoc */
  serialNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  polish?: ApiCutAndPolishType | null;
  /* Template custom: data-contract-jsdoc */
  otherPolish?: string | null;
  /* Template custom: data-contract-jsdoc */
  shape?: ApiShapeType | null;
  /* Template custom: data-contract-jsdoc */
  otherShape?: string | null;
  /* Template custom: data-contract-jsdoc */
  fluorescence?: ApiFluorescenceType | null;
  /* Template custom: data-contract-jsdoc */
  otherFluorescence?: string | null;
  /* Template custom: data-contract-jsdoc */
  historyOfOrigin?: string | null;
  /* Template custom: data-contract-jsdoc */
  typeOfHistoryOfOrigin?: ApiTypeOfHistoryOfOriginType | null;
  /* Template custom: data-contract-jsdoc */
  otherTypeOfHistoryOfOrigin?: string | null;
  /* Template custom: data-contract-jsdoc */
  occasion?: string | null;
  /* Template custom: data-contract-jsdoc */
  source?: string | null;
  /* Template custom: data-contract-jsdoc */
  acquisitionDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  writeOffAccount?: string | null;
  /* Template custom: data-contract-jsdoc */
  insurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  photo?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPrivateDocumentDto {
  /* Template custom: data-contract-jsdoc */
  privateType: ApiPrivateDocumentType;
  /* Template custom: data-contract-jsdoc */
  privateCategory: ApiPrivateDocumentCategory;
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPublicFund {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiPublicFundType | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  fullLegalName: string;
  /* Template custom: data-contract-jsdoc */
  managementBody?: ApiManagementBodyType | null;
  /* Template custom: data-contract-jsdoc */
  typeofBusiness?: string | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityStructure?: string | null;
  /* Template custom: data-contract-jsdoc */
  incorporationDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  fundUsageStrategy?: ApiFundUsageStrategyType | null;
  /* Template custom: data-contract-jsdoc */
  otherFundUsageStrategy?: string | null;
  /* Template custom: data-contract-jsdoc */
  taxNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  taxNumberIssuer?: string | null;
  /* Template custom: data-contract-jsdoc */
  lei?: string | null;
  /* Template custom: data-contract-jsdoc */
  legalEntityAddress?: string | null;
  /* Template custom: data-contract-jsdoc */
  province?: string | null;
  /* Template custom: data-contract-jsdoc */
  zip?: number | null;
  /* Template custom: data-contract-jsdoc */
  city?: string | null;
  /* Template custom: data-contract-jsdoc */
  street?: string | null;
  /* Template custom: data-contract-jsdoc */
  buildingNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  apartments?: string | null;
  /* Template custom: data-contract-jsdoc */
  otherAddressInfo?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiPurchaseValueInline {
  /* Template custom: data-contract-jsdoc */
  calculatedValue?: string | null;
  /* Template custom: data-contract-jsdoc */
  from?: ApiFiatCurrenciesType | null;
  /* Template custom: data-contract-jsdoc */
  value?: number | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiRecurrenceInfo {
  /* Template custom: data-contract-jsdoc */
  is_recurring: boolean;
  /* Template custom: data-contract-jsdoc */
  recurrence_type?:
    | "monthly"
    | "quarterly"
    | "yearly"
    | "weekly"
    | "other"
    | null;
  /* Template custom: data-contract-jsdoc */
  day_of_month?: number | null;
  /* Template custom: data-contract-jsdoc */
  end_date?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiResidencePermitDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  citizenship?: ApiCountry | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  cardAccessNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  dateOfIssue?: string | null;
  /* Template custom: data-contract-jsdoc */
  isPermanent?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  basisOfObtaining?: ApiBasisOfObtainingType | null;
  /* Template custom: data-contract-jsdoc */
  limitations?: string | null;
  /* Template custom: data-contract-jsdoc */
  other?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiResidentialRealEstate {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickName: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type: ApiResidentialRealEstateType;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  addressLabel?: string | null;
  /* Template custom: data-contract-jsdoc */
  district: string;
  /* Template custom: data-contract-jsdoc */
  zipCode: string;
  /* Template custom: data-contract-jsdoc */
  city: string;
  /* Template custom: data-contract-jsdoc */
  street: string;
  /* Template custom: data-contract-jsdoc */
  buildingNumber: string;
  /* Template custom: data-contract-jsdoc */
  apartmentNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  residentialRealEstateNumberName?: string | null;
  /* Template custom: data-contract-jsdoc */
  residentialRealEstateNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  commencementDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  areaOfTheApartments?: number | null;
  /* Template custom: data-contract-jsdoc */
  compositionOfObjects?: string | null;
  /* Template custom: data-contract-jsdoc */
  landPlot?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  landPlotSquare?: number | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSecuritiesAndStocks {
  /* Template custom: data-contract-jsdoc */
  category?: ApiAssetCategory;
  /* Template custom: data-contract-jsdoc */
  nickname: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  type?: ApiSecuritiesAndStocksEnum | null;
  /* Template custom: data-contract-jsdoc */
  purchaseValue: ApiPurchaseValueInline;
  /* Template custom: data-contract-jsdoc */
  amount: number;
  /* Template custom: data-contract-jsdoc */
  keyAssets?: string | null;
  /* Template custom: data-contract-jsdoc */
  quantity?: number | null;
  /* Template custom: data-contract-jsdoc */
  purchasePrice?: number | null;
  /* Template custom: data-contract-jsdoc */
  isin?: string | null;
  /* Template custom: data-contract-jsdoc */
  ticker?: string | null;
  /* Template custom: data-contract-jsdoc */
  issuer?: string | null;
  /* Template custom: data-contract-jsdoc */
  acquisitionDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  brokerageAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositaryName?: string | null;
  /* Template custom: data-contract-jsdoc */
  depositaryAccountNumber?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradeType?: ApiTradeType | null;
  /* Template custom: data-contract-jsdoc */
  seller?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradingPlatformSeller?: string | null;
  /* Template custom: data-contract-jsdoc */
  tradingPlatform?: string | null;
  /* Template custom: data-contract-jsdoc */
  hasInsurance?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  shareOfOwnership?: number | null;
  /* Template custom: data-contract-jsdoc */
  managementRights?: ApiManagerialRightsType | null;
  /* Template custom: data-contract-jsdoc */
  classOfShares?: ApiClassOfSharesType | null;
  /* Template custom: data-contract-jsdoc */
  assetInfoComments?: string | null;
  /* Template custom: data-contract-jsdoc */
  strategyType?: ApiStrategyType | null;
  /* Template custom: data-contract-jsdoc */
  strategyDescription?: string | null;
  /* Template custom: data-contract-jsdoc */
  ownerShipType?: ApiOwnershipType | null;
  /* Template custom: data-contract-jsdoc */
  isWithCoOwners?: boolean | null;
  /* Template custom: data-contract-jsdoc */
  ownerShare?: number | null;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  phoneNumber?: ApiAppLlmSchemasAssetsSharedPartsPhoneNumber | null;
  /* Template custom: data-contract-jsdoc */
  email?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSocialSecurityDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  endDate?: string | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiSubstanceDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  index?: string | null;
  /* Template custom: data-contract-jsdoc */
  city?: string | null;
  /* Template custom: data-contract-jsdoc */
  streetBuilding?: string | null;
  /* Template custom: data-contract-jsdoc */
  basis?: ApiBasisType | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiTaxIDDtoType {
  /* Template custom: data-contract-jsdoc */
  name: string;
  /* Template custom: data-contract-jsdoc */
  names: string;
  /* Template custom: data-contract-jsdoc */
  surnames: string;
  /* Template custom: data-contract-jsdoc */
  country: ApiCountry;
  /* Template custom: data-contract-jsdoc */
  address?: ApiAddress | null;
  /* Template custom: data-contract-jsdoc */
  number?: string | null;
  /* Template custom: data-contract-jsdoc */
  docType?: ApiTaxIDType | null;
  /* Template custom: data-contract-jsdoc */
  storageLocation?: string | null;
  /* Template custom: data-contract-jsdoc */
  comments?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiValidationError {
  /* Template custom: data-contract-jsdoc */
  loc: (string | number)[];
  /* Template custom: data-contract-jsdoc */
  msg: string;
  /* Template custom: data-contract-jsdoc */
  type: string;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseDepositDetailsDto {
  /* Template custom: data-contract-jsdoc */
  bank_name?: string | null;
  /* Template custom: data-contract-jsdoc */
  account_holder_name?: string | null;
  /* Template custom: data-contract-jsdoc */
  iban?: string | null;
  /* Template custom: data-contract-jsdoc */
  bic?: string | null;
  /* Template custom: data-contract-jsdoc */
  account_number?: string | null;
  /* Template custom: data-contract-jsdoc */
  routing_number?: string | null;
  /* Template custom: data-contract-jsdoc */
  reference?: string | null;
  /* Template custom: data-contract-jsdoc */
  instructions?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseFundingDto {
  /* Template custom: data-contract-jsdoc */
  type?: string | null;
  /* Template custom: data-contract-jsdoc */
  status?: string | null;
  /* Template custom: data-contract-jsdoc */
  balance_transaction_id?: number | null;
  /* Template custom: data-contract-jsdoc */
  error_code?: string | null;
  /* Template custom: data-contract-jsdoc */
  error_message?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseQuoteDto {
  /* Template custom: data-contract-jsdoc */
  id: string;
  /* Template custom: data-contract-jsdoc */
  source_currency: string;
  /* Template custom: data-contract-jsdoc */
  target_currency: string;
  /* Template custom: data-contract-jsdoc */
  source_amount?: number | null;
  /* Template custom: data-contract-jsdoc */
  target_amount?: number | null;
  /* Template custom: data-contract-jsdoc */
  rate?: number | null;
  /* Template custom: data-contract-jsdoc */
  status?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseRecipientDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  type: string;
  /* Template custom: data-contract-jsdoc */
  currency: string;
  /* Template custom: data-contract-jsdoc */
  country?: string | null;
  /* Template custom: data-contract-jsdoc */
  account_holder_name?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseRequirementFieldDto {
  /* Template custom: data-contract-jsdoc */
  key: string;
  /* Template custom: data-contract-jsdoc */
  title?: string | null;
  /* Template custom: data-contract-jsdoc */
  required: boolean;
  /* Template custom: data-contract-jsdoc */
  field_type: string;
  /* Template custom: data-contract-jsdoc */
  placeholder?: string | null;
  /* Template custom: data-contract-jsdoc */
  options?: ApiWiseRequirementOptionDto[] | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseRequirementOptionDto {
  /* Template custom: data-contract-jsdoc */
  value: string;
  /* Template custom: data-contract-jsdoc */
  label?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseRequirementsDto {
  /* Template custom: data-contract-jsdoc */
  fields?: ApiWiseRequirementFieldDto[];
}

/* Template custom: data-contract-jsdoc */
export interface ApiWiseTransferDto {
  /* Template custom: data-contract-jsdoc */
  id: number;
  /* Template custom: data-contract-jsdoc */
  status?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAppLlmSchemasAssetsSharedPartsPhoneNumber {
  /* Template custom: data-contract-jsdoc */
  Dropdown?: string | null;
  /* Template custom: data-contract-jsdoc */
  Input?: string | null;
}

/* Template custom: data-contract-jsdoc */
export interface ApiAppLlmSchemasContactContactPhoneNumber {
  /* Template custom: data-contract-jsdoc */
  Dropdown?: ApiPhoneCode | null;
  /* Template custom: data-contract-jsdoc */
  Input?: string | null;
}
